import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';
import '../css/Order.css';
import { ExtendedButton,TextField, Icon, SelectField,MessageBox,DateField,AutocompleteField, Checkbox, EmailField, TariffingProductsToPoints, IbanField } from 'component-lib';
import { DateTimeHelper,CheckValues, Jump,SetRequired,CheckFields,CurrencyConverter } from 'utils-lib';
import { ContractsModel, PaymentsModel, RequestAjaxClass, StreetsModel,OrderContractModel,ConfirmationsModel, Customer, CustomerModel, AccountsModel, Payment, GenderModel } from 'models-lib';
import GlobalConfig from '../globalConfig.json';

var moment = require('moment');
        moment().format();
var stepperIconActiveId = '';
let stepIdPayment = 3;
var Config = require('../projects/'+ GlobalConfig.Project + '/config.json');

class Order  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        //this.CustomerId = localStorage.getItem("vas_customerId");
        this.CustomerId = props.match.params.CustomerId;
        this.ContractId = props.match.params.ContractId;
        this.state.steps = 7;
        this.state.Payments = '';
        this.state.Customer ='';
        this.state.allCertificates = false;
        this.state.IamCustomer = true;
        this.state.CertificateRequired = false;
        this.state.existConfirm = [];
        this.state.Contract = {
          ContractNumber : '',
          TicketName : ''
        };

        this.state.Files = [];
        this.state.NoPayment = false;
        this.state.CustomerEqualAccountOwner = true;

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request4 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request6 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request7 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);

        this.ContractsModel = new ContractsModel([this],null,this.Request);

        this.PaymentsModel = new PaymentsModel([this],null,this.Request2);
        
        this.CustomerAbove = new CustomerModel([this],null,this.Request4);

        this.AccountsModel = new AccountsModel([this],null,this.Request4);

        this.StreetsModel = new StreetsModel([this],null,this.Request);
        this.StreetsModelAccountOwner = new StreetsModel([this],"StreetsAccountOwner", this.Request);

        this.OrderContractModel = new OrderContractModel([this],null, this.Request4);
        
        this.ConfirmationsModel = new ConfirmationsModel([this],null,this.Request3);
        this.CustomerModel = new CustomerModel([this],null,this.Request);

        this.CustomerBDayModel = new CustomerModel([this],"CustomerBDay",this.Request7);

        this.Customer = new Customer();
        this.CustomerBDay = new Customer();

        this.Payment = new Payment();

        this.AccountOwner = new Customer();

        this.FileText = React.createRef();

        this.VerificationMonthRef = React.createRef();
        this.UploadCertificateRef = React.createRef();

        this.updloadedFiles = 0;
        this.filesCount = 0;
        this.filesCountCur = 0;

        this.ChosenTariff = "";

        // eslint-disable-next-line no-unused-expressions
        this.Request5 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        this.GenderModel = new GenderModel([this], null, this.Request5);

        this.CompanyAbove = new CustomerModel([this],null,this.Request6);

        this.Request5.setAuth(false);
        this.Request5.setApiKey(Vas.ApiKey);
        this.Request5.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();

        this.Request6.setAuth(false);
        this.Request6.setApiKey(Vas.ApiKey);
        this.Request6.setApiUrl(Vas.ApiUrl);

        /*if(localStorage.getItem('vas_role') === '3'){
          
          if(this.CustomerId === "00000"){

              if(localStorage.getItem('vas_customerId') != null || localStorage.getItem('vas_customerId') != undefined){
                let date = moment().format("YYYY-MM-DD T 00:00:00");
                this.CompanyAbove.GetCustomersAboveByCustomerId(localStorage.getItem('vas_customerId'),date,true);
              }

          }
        }*/

        localStorage.removeItem("SelectedProductName");

        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.UploadConfig = Vas.Config.DocumentUpload;
    }

    componentDidMount(){
      localStorage.removeItem('TariffProducts');

        this.Request.setAuth(true);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);

        this.Request2.setAuth(true);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);

        this.Request3.setAuth(true);
        this.Request3.setApiKey(Vas.ApiKey);
        this.Request3.setApiUrl(Vas.ApiUrl);

        this.Request4.setAuth(true);
        this.Request4.setApiKey(Vas.ApiKey);
        this.Request4.setApiUrl(Vas.ApiUrl);

        this.Request7.setAuth(true);
        this.Request7.setApiKey(Vas.ApiKey);
        this.Request7.setApiUrl(Vas.ApiUrl);

        //document.getElementById("checkboxIamCustomer").checked = true;

        Jump.jump(this.state.steps,1,1,stepperIconActiveId);

        let reqFields = [{Key:this.refs.name,Index:10,Step:3},
                          {Key: this.refs.firstName,Index:11,Step:3},
                          {Key:this.refs.dateOfBirth,Index:12,Step:3}, 
                          {Key:this.refs.zip,Index:16,Step:4}, 
                          {Key:this.refs.city,Index:17,Step:4}, 
                          {Key:this.refs.street,Index:18,Step:4}, 
                          {Key:this.refs.houseNumber,Index:19,Step:4}];

        let reqBankfields = [
                          {Key:this.refs.accountOwnerName, Index:20,Step:3},
                          {Key:this.refs.accountOwnerFirstName, Index: 21, Step: 3},
                          {Key:this.refs.dateOfBirthAccountOwner,Index:22,Step:3}, 
                          {Key:this.refs.iban ,Index: 32,Step:3},
                          {Key:this.refs.bic ,Index: 33,Step:3}
        ];

        let reqFieldsAccountOwner = [{Key: this.refs.zipAccountOwner,Index:25,Step:3},
                                      {Key:this.refs.cityAccountOwner,Index:26,Step:3},
                                      {Key:this.refs.streetAccountOwner,Index:27,Step:3}, 
                                      {Key:this.refs.houseNumberAccountOwner,Index:28,Step:3}
                                    ];

        let reqSelectFieldsAccountOwner = [{Key: this.refs.genderAccountOwner , Index: 24 , Step:3}];

        let requiredSelectfields = [{Key:this.refs.gender,Index:23,Step:3}];
                                   
        if(this.ContractId !== "00000"){
          this.ContractsModel.GetContractByContractId(this.ContractId);
        }

        if(this.CustomerId !== "00000"){
          this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId,null,0,50);
          this.CustomerBDayModel.GetCustomerById(this.CustomerId);
        }
        
        if(localStorage.getItem('vas_role') === '3'){
          if(this.CustomerId === "00000"){
            this.AccountsModel.Own();
            //reqFields.push({Key:this.refs.email, Index:10, Step: 2});
            //reqFields.push({Key:this.refs.emailRepeat, Index:11, Step: 2});

              if(localStorage.getItem('vas_customerId') != null || localStorage.getItem('vas_customerId') != undefined){

                /*if(this.CompanyAbove.CustomersAbove.length > 1){
                  requiredSelectfields.push({Key:this.refs.company, Index:5, Step: 2});
                }*/

                this.state.IamCustomer = false;
              }

          }else{
            //let date = moment().format("YYYY-MM-DD T 00:00:00");
            //this.CustomerAbove.GetCustomersAboveByCustomerId(this.CustomerId,date);
          }
        }

        this.setState({ requiredSelectField:[{Key:this.refs.Payment,Index:32,Step:3}],
            requiredCeckBox:[{Key:this.refs.AcceptPaymentTerms,Index:35,Step:3}],
            requiredCustomerFields : reqFields,
            requiredCustomerSelectfields: requiredSelectfields,
            requiredBankFields:reqBankfields,
            requiredFieldsAccountOwner : reqFieldsAccountOwner,
            requiredSelectFieldsAccountOwner : reqSelectFieldsAccountOwner },()=>{ 
              //SetRequired.Set(null,this.state.requiredSelectField);
              $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.LogoClick();

        this.FontSizeClick();
    }

    componentDidUpdate(){
      this.FontSizeClick();
    }

    Update(observer)
    {
      console.log(observer);
      let me = this;
      me.setState({},()=>{
        if(observer === "ContractById"){
          me.setState({Contract:{ContractNumber:me.ContractsModel.Contract.ContractNumber, TicketName: me.ContractsModel.Contract.TicketName, CustomerName: me.ContractsModel.Contract.CustomerName}});
        }
        else if(observer === "Payment"){
          
            let payments = [];
            me.PaymentsModel.Payments.forEach(function(value) {
                    
              if (value.PaymentMethodValue === 4){
                  let payment = {};
                  payment.Id = value.Id;
                  payment.BankName = value.BankName;
                  payment.AccountOwner = value.AccountOwner;
                  payment.Iban=value.Iban;

                  let from = moment();
                  let to = moment();
                  let fromValue = null;
                  let toValue = null;
                  if (value.ValidFrom !== null && value.ValidFrom !== "")
                      {from = moment(value.ValidFrom);
                      fromValue = moment(value.ValidFrom);}
                  if (value.ValidTo !== null && value.ValidTo !== "")
                      {to = moment(value.ValidTo);
                      toValue = moment(value.ValidTo);}
                  payment.ValidFrom = fromValue;
                  payment.ValidTo = toValue;
                  payment.IsDefaultPaymentMethod=value.IsDefaultPaymentMethod;
                  let today = moment();
                  if (((from.isSameOrBefore(today)) && (to.isSameOrAfter(today)))
                  ||((from.isSameOrBefore(today))&&(value.ValidTo === null))
                  ||((value.ValidFrom === null)&&(to.isSameOrAfter(today)))
                  ||((value.ValidFrom === null)&&(value.ValidTo === null)))
                  {
                      payments.push(payment);
                  }
              }
            });
            
            let defaultPayment = '';
            let paymentList = [];
            for (let i = 0; i< payments.length; i++){
                if (payments[i].IsDefaultPaymentMethod === true){
                    defaultPayment = payments[i].BankName + "(" + payments[i].Iban.substring(payments[i].Iban.length-6) + ")";
                }
                paymentList.push({ Key:payments[i].Id, Display:payments[i].BankName + "(" + payments[i].Iban.substring(payments[i].Iban.length-6) + ")" });

            }
            if (me.refs){
                if (me.refs.Payment){
                    me.refs.Payment.setState({ Data:paymentList, Default: defaultPayment });
                }
            }
            me.setState({Payments:payments});
        }
        else if(observer === "Streets"){
          me.refs.street.setState({ Data: me.StreetsModel.Streets, Icon :'',placeholder:'' });
        }
        else if(observer === "StreetsAccountOwner"){
          let streets = [];
          if (me.StreetsModelAccountOwner.Streets)
          {
              streets = me.StreetsModelAccountOwner.Streets;
          }
          me.refs.streetAccountOwner.setState({ Data: streets, Icon :'',placeholder:'' });
        }
        else if( observer === "Contracts" || observer === "ContractsWithConfirmations"){
          localStorage.removeItem('Tariff');
          if(me.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
            let customerId = me.OrderContractModel.Response.Contract.IdCustomer;
            localStorage.setItem("CustomerId", customerId);
            localStorage.setItem("ContractNumber", me.OrderContractModel.Response.Contract.ContractNumber);

            localStorage.setItem('ContractOverviewTariffPointFromAtg', me.OrderContractModel.Response.ContractConnection.AtgFrom);
            localStorage.setItem('ContractOverviewTariffPointToAtg', me.OrderContractModel.Response.ContractConnection.AtgTo);

            if(me.state.ConfirmationsRequired === true){

              localStorage.setItem("ExecutingForm", "OrderContract");

            }else{
              Vas.GetView('OrderSuccess',null,true);
            }
          }else{
            Vas.GetView('OrderSuccess',null,true);
          }
        }
        else if(observer === "ConfirmationsByTicketId"){
          //ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer')); 
          
          let rqSelectField = this.state.requiredSelectField;
          let rqCheckBox = this.state.requiredCeckBox;

          $("#LoadingIconPopUp").removeClass().addClass('hide');
          if (me.ConfirmationsModel.Confirmations.length > 0){
            
            rqSelectField = this.changeRequiredFieldsIndex(rqSelectField,this.state.IamCustomer,true);
            rqCheckBox = this.changeRequiredFieldsIndex(rqCheckBox,this.state.IamCustomer,true);
            me.setState({ConfirmationsRequired : true, 
              RequiredConfirmations : me.ConfirmationsModel.Confirmations,
              requiredSelectField: rqSelectField,
              requiredCeckBox: rqCheckBox
            },()=>{
              me.getConfirmationFields(me.ConfirmationsModel.Confirmations);
            });
          } else {
            rqSelectField = this.changeRequiredFieldsIndex(rqSelectField,this.state.IamCustomer,false);
            rqCheckBox = this.changeRequiredFieldsIndex(rqCheckBox,this.state.IamCustomer,false);
            me.setState({ allCertificates: true, 
              ConfirmationsRequired : false,
              requiredSelectField: rqSelectField,
              requiredCeckBox: rqCheckBox });
          }
        }
        else if(observer === "UploadConfirmation"){
          if(this.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
            me.updloadedFiles-= 1;
            me.filesCountCur++;

            if(me.filesCount === me.filesCountCur){
              $("#LoadingIconPopUp").removeClass().addClass('hide');
              if (me.updloadedFiles === 0){
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
                  Vas.GetView('OrderSuccess',null,true);
              } else {
                ReactDOM.render(<MessageBox
                    AppURL={Vas.ApplicationUrl}
                    Id={"MessageBox"}
                    Title={Vas.Resources.Labels["Order"]}
                    Message={Vas.Resources.Labels["NotAllVerification"]} />, document.getElementById('messageContainer'));
              }
            }
          }else{
            let exist = []; 
            exist = me.state.existConfirm;
            exist.push(me.state.field);
            me.setState({ field: null, existConfirm:exist,CertificationType:null,CertificateStart:null,CertificateEnd:null,IdentificationNumber:null,requiredFieldsCertificate:null, files:null, fileName:'' });
            $('#uploadFields').removeClass().addClass('uploadFields');
            ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
            me.getConfirmationFields();
          }
          
        }
        else if(observer === "Customer"){

          if(this.ChosenTariff != ''){

          //me.setState({Customer:data.Data[0]});
          let id = '';
          if (me.ContractId !== '00000'){
              id = me.ContractId;
          } else {
              id = null;
          }

          this.OrderContractModel.ContractIdToChange = id;
          
          let tariff = this.ChosenTariff;
          this.OrderContractModel.ContractStart = tariff[1].ContractStart;
          this.OrderContractModel.ContractEnd = tariff[0].ContractEnd;
          this.OrderContractModel.CreateAccount = false;
          this.OrderContractModel.DeliveryToSchool = true;

          if(me.state.IamCustomer === true){
            this.OrderContractModel.Customer = this.CustomerModel.Customer;
            this.OrderContractModel.CustomerLegalGuardian = null;
          } else {
            
            this.OrderContractModel.Customer = this.Customer;
            
            if(this.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
              this.OrderContractModel.CustomerLegalGuardian = null;
            }else{
              if(this.Customer.Name1 === this.CustomerModel.Customer.Name1 &&
                  this.Customer.Name2 === this.CustomerModel.Customer.Name2 &&
                  DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).isSame(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')),'day')){
                    this.OrderContractModel.Customer = this.CustomerModel.Customer;
                    this.OrderContractModel.CustomerLegalGuardian = null;
                  }else{
                    this.OrderContractModel.CustomerLegalGuardian = this.CustomerModel.Customer;
                  }
            }
          }

          this.OrderContractModel.CustomerAccountOwner=null;

          if(this.state.CustomerEqualAccountOwner === false){
            this.OrderContractModel.CustomerAccountOwner = this.AccountOwner;
          }
   
          //Hier bei der Reschnungsanschrift null übergeben
          //Wird hier nichts übergeben, wird eine leere Rechnungsanschrift im VAS angelegt
          this.OrderContractModel.CustomerBillAddress = null;

          let paymentId = $("#Payments").val();
          let selPayment = '';
          for (let i =0; i< me.state.Payments.length; i++){
              if (me.state.Payments[i].Id === paymentId){
                  selPayment = me.state.Payments[i];
              }
          }

          let defaultPayment = false;
          if (selPayment.IsDefaultPaymentMethod !== ''){
              defaultPayment = true;
          }

          let curValidFrom = selPayment.ValidFrom;
          let curValidTo = selPayment.ValidTo;

          if(this.state.NoPayment === false){
            if(this.CustomerId === "00000"){
              this.Payment.AccountOwner = this.AccountOwner.Name2 + " " + this.AccountOwner.Name1;
              this.Payment.PaymentMethodValue = 4;
              this.OrderContractModel.CustomerPaymentOption = this.Payment;
            }else{
              this.OrderContractModel.CustomerPaymentOption = {
                AccountOwner: selPayment.AccountOwner,
                BankName: selPayment.BankName,
                Iban: selPayment.Iban,
                Id: selPayment.Id,
                IsDefaultPaymentMethod: defaultPayment,
                PaymentMethod: "",
                PaymentMethodValue: 4,
                ValidFrom:curValidFrom ,
                ValidTo:curValidTo 
              };
            }
            
          } else {
              this.Payment.PaymentMethodValue = Config.NoPaymentPaymentMethode;
              this.OrderContractModel.CustomerPaymentOption = this.Payment;
          }
          
          this.OrderContractModel.SchoolId = null;
          if(localStorage.getItem("vas_role") === "3"){

           /* if($('#Company').val() != undefined){
              this.OrderContractModel.SchoolId = $('#Company').val();
            } else{

              for(let i = 0; i<this.CustomerAbove.CustomersAbove.length;i++){
                  let customerAboveValidFrom = DateTimeHelper.StringToDate(this.CustomerAbove.CustomersAbove[i].ValidFrom,true,localStorage.getItem('vas_language'));
                  let contractStart = DateTimeHelper.StringToDate(this.OrderContractModel.ContractStart,true,localStorage.getItem('vas_language'));
                  if(contractStart.isSameOrAfter(customerAboveValidFrom)){
                    this.OrderContractModel.SchoolId = this.CustomerAbove.CustomersAbove[i].Id;
                  }
              }
            }*/
            this.OrderContractModel.SchoolId = tariff[3];
          }

          this.OrderContractModel.SiblingChildren =[];

          this.OrderContractModel.TariffPointFrom = tariff[1];

            if(tariff[1].Version == ""){
              this.OrderContractModel.TariffPointFrom.Version = "0001-01-01 00:00:00";
            }

            if(tariff[1].TariffPointType == ""){
              this.OrderContractModel.TariffPointFrom.TariffPointType = "0";
            }

            this.OrderContractModel.TariffPointTo = tariff[2];

            if(tariff[2].Version == ""){
              this.OrderContractModel.TariffPointTo.Version = "0001-01-01 00:00:00";
            }

            if(tariff[2].TariffPointType == ""){
              this.OrderContractModel.TariffPointTo.TariffPointType = "0";
            }
            
            if(tariff[2].ContractStart == ""){
              this.OrderContractModel.TariffPointTo.ContractStart = "0001-01-01 00:00:00";
            }

            this.OrderContractModel.TariffProduct = tariff[0];

          //let referenc = me.props.reference;
          //let table = me.props.table;

          var dateOfBirth = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.OrderContractModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')));

          localStorage.setItem('ContractOverviewCustomer',JSON.stringify(this.OrderContractModel.Customer));
          localStorage.setItem('ContractOverviewCustomerBirthdate', $("#DateOfBirth").val() == "" ? dateOfBirth : $("#DateOfBirth").val());
          localStorage.setItem('ContractOverviewCustomerPayment',JSON.stringify(this.OrderContractModel.CustomerPaymentOption));
          localStorage.setItem('ContractOverviewTariffPointFrom',JSON.stringify(this.OrderContractModel.TariffPointFrom));
          localStorage.setItem('ContractOverviewTariffPointTo',JSON.stringify(this.OrderContractModel.TariffPointTo));
          localStorage.setItem('ContractOverviewTariffProduct',JSON.stringify(this.OrderContractModel.TariffProduct));
          localStorage.setItem('ContractOverviewContractStart', DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(tariff[1].ContractStart,true,localStorage.getItem('vas_language'))));
          localStorage.setItem('ContractOverviewContractEnd', this.OrderContractModel.ContractEnd !== null ? DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.OrderContractModel.ContractEnd,true,localStorage.getItem('vas_language'))): "");
          
          if(this.state.CustomerEqualAccountOwner === false){
            localStorage.setItem('AccountOwner',JSON.stringify(this.AccountOwner));
            localStorage.setItem('AccountOwnerBirthDate', $("#DateOfBirthAccountOwner").val());
          }

          let files = this.state.Files;
            let confirmationId = "";
            let dateFrom = "";
            let dateTo = "";
            let identificationNumber = "";
            let formData = files;

            if(this.state.ConfirmationsRequired === true){
                            
              localStorage.setItem("ExecutingForm", "OrderPopUp");

              for (let i = 0; i< files.length; i++){
                confirmationId += formData[i].confirmationId + ";";
                dateFrom += formData[i].datefrom + ";";
                dateTo += formData[i].dateto + ";";
                identificationNumber += formData[i].identificationNumber + ";";
              }

              this.OrderContractModel.Contracts("", confirmationId, dateFrom, dateTo, identificationNumber, formData);
            } else{
              this.OrderContractModel.Contracts();
            }
          }
        }
        else if(observer === "AccountsOwn"){
          if (me.AccountsModel.Customer){
            me.Customer.ClientId = me.AccountsModel.Customer.ClientId;
            let rqSelectField = this.state.requiredCustomerSelectfields;
            let rqTextFields = this.state.requiredCustomerFields;

            rqSelectField = this.changeRequiredFieldsIndex(rqSelectField,this.state.IamCustomer,false);
            rqTextFields = this.changeRequiredFieldsIndex(rqTextFields,this.state.IamCustomer,false);
 
            me.setState({IamCustomer : false, 
              NoPayment : true, 
              requiredCustomerFields : rqTextFields,
              requiredCustomerSelectfields: rqSelectField});
          }
        }
        else if(observer === "InsertCustomer"){

          this.Customer = this.CustomerModel.Customer;
          //let date = moment().format("YYYY-MM-DD T 00:00:00");

          //this.CustomerAbove.GetCustomersAboveByCustomerId(this.Customer.Id,date);
          if(this.CustomerId === "00000" && localStorage.getItem('vas_role') === "3"){
            this.Update("Customer");
          }

        }
        else if(observer === "CustomersAbove"){
          if(this.CustomerId === "00000" && localStorage.getItem('vas_role') === "3"){
            this.Update("Customer");
          }
        }
        else if(observer === "CustomerBDay"){
          this.CustomerBDay = this.CustomerBDayModel.Customer;
        }
        else if(observer === "Gender"){
          let genderSelection = []
      
          if(this.GenderModel.Gender.length > 0){

            let genderArray = this.GenderModel.Gender;

            if(genderArray.length === 2) {
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
            } else if(genderArray.length === 3){
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
            }
          }
          this.setState({GenderValues : genderSelection});
          if(this.refs.gender){
            this.refs.gender.setState({Data:genderSelection});
          }
          
        }
      });

      this.FontSizeClick();
    }

    jump(id,stepId)//springe zu einem anderen Stepperfeld
    {
      
      if(stepId === "1" || stepId === undefined){
        /*let tariff = this.refs.Tariffing.returnTariffProduct();
        this.ChosenTariff = tariff;
        if(tariff[0]!== null){
          if(tariff[0].IdTicket !== null && tariff[0].IdTicket !== undefined){
            this.getConfirmation(tariff[0].IdTicket);
            
          }
        }*/
        this.getConfirmation();
      }

      this.updatePersonalData();

      stepperIconActiveId =Jump.jump(this.state.steps,id,stepId,stepperIconActiveId);

      if(stepperIconActiveId === "3"){
        this.setRequiredAge();
      }

      //Hier die ersten Controls entsptechend der übergebenen curId & curStepId setzen
      if((id === 1 && stepId === 2) || (id === 1 && stepId === 0)){
        if(document.getElementById("TariffProducts") != null){
          document.getElementById("TariffProducts").focus();
        }
      }
      if((id === 2 && stepId === 3) || (id === 2 && stepId === 0) || (id === 4 && stepId === 0)){
        if(document.getElementById("div_checkboxIamCustomer") != null){
          document.getElementById("div_checkboxIamCustomer").focus();
        }

        if(document.getElementById("Zip") != null){
          document.getElementById("Zip").focus();
        }
      }
      if((id === 3 && stepId === 4) || (id === 3 && stepId === 0)){
        if(document.getElementById("Payments") != null){
          document.getElementById("Payments").focus();
        }
        if(document.getElementById("Name1") != null){
          document.getElementById("Name1").focus();
        }
      }

      this.LogoClick();

      this.FontSizeClick();

    }

    updatePersonalData(){

      //ContractData
      document.getElementById("TariffProduct_TicketName").innerText =
      document.getElementById("TariffProducts") == null || document.getElementById("TariffProducts") == undefined 
        ? '' 
        : document.getElementById("TariffProducts").selectedIndex == 0 
          ? ''
          : document.getElementById("TariffProducts")[document.getElementById("TariffProducts").selectedIndex].innerText;
      
      if(document.getElementById('ContractStart').selectedIndex > -1) {
        document.getElementById("TariffProduct_ContractStart").innerText = document.getElementById('ContractStart').selectedIndex == 0 ? '' : document.getElementById('ContractStart')[document.getElementById('ContractStart').selectedIndex].innerText;
      }
      
      if(this.refs.Tariffing.ProductModel.ProductList.length > 0){
        if(this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-37-02" || 
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-45-02" || 
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-43-02" || 
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-47-02"){
          document.getElementById("TariffProduct_FromHeadline").style.display = 'none';
          document.getElementById("TariffProduct_DescriptionLongFrom").style.display = 'none';
          document.getElementById("TariffProduct_ToHeadline").style.display = 'none';
          document.getElementById("TariffProduct_DescriptionLongTo").style.display = 'none';
        }
      } else{
        if(document.getElementById('i-7') != null){
          document.getElementById("TariffProduct_DescriptionLongFrom").innerText = document.getElementById('i-7').innerText.substring(6);
          document.getElementById("TariffProduct_TzViaText").style.display = 'none';
        } else{
          if(document.getElementById('From') == null){
            document.getElementById("TariffProduct_FromHeadline").style.display = 'none';
            document.getElementById("TariffProduct_DescriptionLongFrom").style.display = 'none';
          } else{
            document.getElementById("TariffProduct_DescriptionLongFrom").innerText = document.getElementById('From').value;
          }
  
          if(document.getElementById('To') == null){
            document.getElementById("TariffProduct_ToHeadline").style.display = 'none';
            document.getElementById("TariffProduct_DescriptionLongTo").style.display = 'none';
          } else{
            document.getElementById("TariffProduct_DescriptionLongTo").innerText = document.getElementById('From').value;
          }
        }
      }

      if(this.refs.Tariffing.ProductModel.ProductList.length > 0){
        if(this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-35-02" || 
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-38-02" ||
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-39-02" ||
        this.refs.Tariffing.ProductModel.ProductList[0].TicketIdent == "01-40-02"){

          if((this.refs.Tariffing.ProductModel.ProductList[0].PriceLevel == "1 Zone" || 
        this.refs.Tariffing.ProductModel.ProductList[0].PriceLevel == "2 Zonen" || 
        this.refs.Tariffing.ProductModel.ProductList[0].PriceLevel == "kleiner Stadtverkehr") && 
        (this.refs.Tariffing.ProductModel.ProductList[0].TzViaText == "direkt"|| 
        this.refs.Tariffing.ProductModel.ProductList[0].TzViaText == "direkter Weg")){
          document.getElementById("TariffProduct_TzViaLabel").style.display = 'none';
          document.getElementById("TariffProduct_TzViaText").style.display = 'none';
        } else{
          document.getElementById("TariffProduct_FromHeadline").style.display = 'none';
          document.getElementById("TariffProduct_DescriptionLongFrom").style.display = 'none';
          document.getElementById("TariffProduct_ToHeadline").style.display = 'none';
          document.getElementById("TariffProduct_DescriptionLongTo").style.display = 'none';

          if(document.getElementById('Via') != null ){

            var sel = document.getElementById("Via");
            if(sel.options[sel.selectedIndex]){
              var text= sel.options[sel.selectedIndex].text;
  
              document.getElementById("TariffProduct_TzViaText").innerText = this.refs.Tariffing.ProductModel.ProductList.length == 0 
                ? '' 
                : document.getElementById('Via').selectedIndex == 0 
                    ? '' 
                    : text;
            }
            
          } else{
            document.getElementById("TariffProduct_TzViaLabel").style.display = 'none';
            document.getElementById("TariffProduct_TzViaText").style.display = 'none';
          }
        }
          if(document.getElementById('Via') != null ){

            var sel = document.getElementById("Via");
            if(sel.options[sel.selectedIndex]){
              var text= sel.options[sel.selectedIndex].text;

              document.getElementById("TariffProduct_TzViaText").innerText = this.refs.Tariffing.ProductModel.ProductList.length == 0 
                ? '' 
                : document.getElementById('Via').selectedIndex == 0 
                    ? '' 
                    : text;
            }
            
          }
        }
      } else {
        if(document.getElementById('Via') != null ){

          var sel = document.getElementById("Via");
          if(sel.options[sel.selectedIndex]){
            var text= sel.options[sel.selectedIndex].text;

            document.getElementById("TariffProduct_TzViaText").innerText = this.refs.Tariffing.ProductModel.ProductList.length == 0 
              ? '' 
              : document.getElementById('Via').selectedIndex == 0 
                  ? '' 
                  : text;
          }
          
        } else{
          document.getElementById("TariffProduct_TzViaLabel").style.display = 'none';
          document.getElementById("TariffProduct_TzViaText").style.display = 'none';
        }
      }

      document.getElementById("TariffProduct_Price").innerText = document.getElementById('Price').value;

      document.getElementById("TariffProduct_PriceLevel").innerText = this.refs.Tariffing.ProductModel.ProductList.length == 0 
        ? '' 
        : this.refs.Tariffing.ProductModel.ProductList[0].PriceLevel;

      document.getElementById("TariffProduct_ContractEnd").innerText = document.getElementById('ContractEnd').value;

      //Daten gesetzlicher Vertreter
      if(this.state.IamCustomer == false){

        //PersonalData Legaluardian
        document.getElementById("PersonalDataTicketOwner_Name1").innerText = this.Customer.Name1;
        document.getElementById("PersonalDataTicketOwner_Name2").innerText = this.Customer.Name2;

        let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
        document.getElementById("PersonalDataTicketOwner_DateOfBirth").innerText = $("#DateOfBirth").val() == "" ? "" : moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
        document.getElementById("PersonalDataTicketOwner_Gender").innerText = this.Customer.Gender;

        document.getElementById("PersonalDataTicketOwner_Email").innerText = this.Customer.Email;
        document.getElementById("PersonalDataTicketOwner_Phone").innerText = this.Customer.Phone == undefined ? "" : this.Customer.Phone;

        //AddressData LegalGuardian
        document.getElementById("AddressDataTicketOwner_Zip").innerText = this.Customer.PostCode == undefined ? "" : this.Customer.PostCode;
        document.getElementById("AddressDataTicketOwner_Place").innerText = this.Customer.City;

        document.getElementById("AddressDataTicketOwner_Street").innerText = this.Customer.Street;

        document.getElementById("AddressDataTicketOwner_HouseNumber").innerText = this.Customer.HouseNumber;
        document.getElementById("AddressDataTicketOwner_HouseNumberAddition").innerText = this.Customer.HouseNumberAddition;

        document.getElementById("AddressDataTicketOwner_AddressAddition").innerText = this.Customer.Name3 == undefined ? "" : this.Customer.Name3;     
      }

      if(this.state.CustomerEqualAccountOwner === false){
        document.getElementById("AddressDataAccountOwner_Gender").innerText = this.AccountOwner.Gender;
        document.getElementById("AddressDataAccountOwner_Zip").innerText = this.AccountOwner.Zip == undefined ? "" : this.AccountOwner.Zip;
        document.getElementById("AddressDataAccountOwner_Place").innerText = this.AccountOwner.City;

        document.getElementById("AddressDataAccountOwner_Street").innerText = this.AccountOwner.Street;

        document.getElementById("AddressDataAccountOwner_HouseNumber").innerText = this.AccountOwner.HouseNumber;
        document.getElementById("AddressDataAccountOwner_HouseNumberAddition").innerText = this.AccountOwner.HouseNumberAddition;

        document.getElementById("AddressDataAccountOwner_AddressAddition").innerText = this.AccountOwner.Name3 == undefined ? "" : this.AccountOwner.Name3;
      }
      //PaymentData
      if(this.state.NoPayment === false) {

        if(document.getElementById('Payments') !== null && document.getElementById('Payments').selectedIndex > -1) {
          document.getElementById("Payment_Payment").innerText = document.getElementById('Payments')[document.getElementById('Payments').selectedIndex].innerText;
        } else{
          document.getElementById("PaymentData_DepositorName").innerText = this.AccountOwner.Name1 == undefined ? "" : this.AccountOwner.Name1;
          document.getElementById("PaymentData_DepositorFirstname").innerText = this.AccountOwner.Name2 == undefined ? "" : this.AccountOwner.Name2;

          document.getElementById("PaymentData_Iban").innerText = this.Payment.Iban == undefined ? "" : this.Payment.Iban;

          document.getElementById("PaymentData_Bic").innerText = this.Payment.Bic == undefined ? "" : this.Payment.Bic;

          document.getElementById("PaymentData_NameOfBank").innerText = this.Payment.BankName == undefined ? "" : this.Payment.BankName;
        }
      }
      
    }

    changeRequiredFieldsIndex(reqFields,iAmCustomer,verification){
      for(let i = 0; i<reqFields.length; i++){
        if(reqFields[i].Index && reqFields[i].Step){
          if(reqFields[i].Index > 19){
            if(iAmCustomer === true && verification === true){
              reqFields[i].Step = 3;
            }
            if(iAmCustomer === false && verification === true){
              reqFields[i].Step = 5;
            }
            if(iAmCustomer === true && verification === false){
              reqFields[i].Step = 3;
            }
            if(iAmCustomer === false && verification === false){
              reqFields[i].Step = 5;
            }

            if(localStorage.getItem('vas_role') === '3'){
              reqFields[i].Step--;
            }
          }
          else if(reqFields[i].Index >= 10 && reqFields[i].Index < 19){
            if(this.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
              reqFields[i].Step = reqFields[i].Step - 1;
            }
          }
        }
      }
      return reqFields
    }

    BackToCustomer(){
      if(this.CustomerId === "00000"){
        Vas.GetView("Customers",null,true);
      }else{
        Vas.GetView("CustomerCard",{ Id:this.CustomerId },true);
      }
    }

    checkAccountOwner(){
      if(this.AccountOwner.Name1.length > 0 && this.AccountOwner.Name2.length > 0 && this.AccountOwner.DateOfBirth.length > 0){
        if(this.AccountOwner.Name1 === this.Customer.Name1 
          && this.AccountOwner.Name2 === this.Customer.Name2 
          && DateTimeHelper.StringToDate(this.AccountOwner.DateOfBirth,true,localStorage.getItem('vas_language')).isSame(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem('vas_language')),'day') )
          {
            this.setState({CustomerEqualAccountOwner:true});
          }else {
            this.setState({CustomerEqualAccountOwner:false},()=>{
              this.setState({
                requiredFieldsAccountOwner:[{Key: this.refs.zipAccountOwner,Index:25,Step:3},
                  {Key:this.refs.cityAccountOwner,Index:26,Step:3},
                  {Key:this.refs.streetAccountOwner,Index:27,Step:3}, 
                  {Key:this.refs.houseNumberAccountOwner,Index:28,Step:3}
                ],
                requiredSelectFieldsAccountOwner : [{Key: this.refs.genderAccountOwner , Index: 24 , Step:3}]
              })
            });
          }
      }else{
         this.setState({CustomerEqualAccountOwner:true});
      }
    }

    getRequiredAge(ticketId){
      
      let tariff = this.refs.Tariffing.returnTariffProduct();
      //let tariff = '';
      
      if(ticketId){
        let products = JSON.parse(localStorage.getItem('TariffProducts'));
        for(let i = 0; i<products.length; i++){
          if(products[i].IdTicket === ticketId){
            tariff = products[i];
          }
        }
      }
      
      let rqAge = 0;
      let maxAge = 0;
      let contractStart = moment();

      if(tariff){
        if(tariff[0]){
          if(tariff[0].RequiredAge){
            rqAge = tariff[0].RequiredAge;
          }
          if(tariff[0].MaximumAge){
            maxAge = tariff[0].MaximumAge;
          }
        }else{
          if(tariff.RequiredAge){
            rqAge = tariff.RequiredAge;
          }
          if(tariff.MaximumAge){
            maxAge = tariff.MaximumAge;
          }
        }
        if(tariff[1]){
          if(tariff[1].ContractStart){
            contractStart = DateTimeHelper.StringToDate(tariff[1].ContractStart,true,localStorage.getItem('vas_language')) ;
          }
        }

      }

      return [rqAge,maxAge,contractStart]
    }

    showRequiredAge(ticketId){
      document.getElementById('HintRequiredAge').innerHTML = '';
      document.getElementById('HintMaxAge').innerHTML = '';
      let result = this.getRequiredAge(ticketId);
      
      if(result[0] !== 0 ){
        document.getElementById('HintRequiredAge').innerHTML = Vas.Resources.Labels["RequiredAge1"] + result[0] + Vas.Resources.Labels["RequiredAge2"];
      }else{
        document.getElementById('HintRequiredAge').innerHTML = '';
      }

      if(result[1] !== 0){
        document.getElementById('HintMaxAge').innerHTML = Vas.Resources.Labels["RequiredAge3"] + result[1] + Vas.Resources.Labels["RequiredAge2"];
      }else{
        document.getElementById('HintMaxAge').innerHTML = '';
      }
    }

    setRequiredAge(){
      let result = this.getRequiredAge();
      let message = [];
      let maxValue = true;
      if(result[0] !== 0 ){
        let minBDay = moment([result[2].year(),result[2].month(),result[2].date()]).subtract(result[0], 'years');
        if(this.state.IamCustomer === true){

          let customerBDay = DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem('vas_language'));

          if(customerBDay.isBefore(minBDay,'day') === false){
            message.push(Vas.Resources.Labels["RequiredAge1"] + result[0] + Vas.Resources.Labels["RequiredAge2"]);
            {/*ReactDOM.render(<MessageBox 
              Message={ Vas.Resources.Labels["RequiredAge1"] + result[0] + Vas.Resources.Labels["RequiredAge2"]} 
              Title={Vas.Resources.Titles["Note"]}
              
              />
            ,document.getElementById('messageContainer'));*/}
            maxValue = false;
          }
          else{
            maxValue = true;
          }
        }else{
          this.refs.dateOfBirth.setState({ MaxValue: moment([minBDay.year(),minBDay.month(), minBDay.date()]),
                                  FalseMaxDateText : Vas.Resources.Labels["RequiredAge1"] + result[0] + Vas.Resources.Labels["RequiredAge2"] });
          maxValue = true;
        }
      }else{
        this.refs.dateOfBirth.setState({ MaxValue: moment(),
          FalseMaxDateText :  Vas.Resources.Labels["NoFutureDateOfBirth"] });
        maxValue = true;
      }

      let minValue = true;
      if(result[1] !== 0){
        let maxBDay = moment([result[2].year(),result[2].month(),result[2].date()]).subtract(result[1], 'years');

        if(this.state.IamCustomer === true){
          let customerBDay = DateTimeHelper.StringToDate(this.CustomerBDayModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language'));
          if(maxBDay.isAfter(customerBDay,'day') === true){
            message.push(Vas.Resources.Labels["RequiredAge3"] + result[1] + Vas.Resources.Labels["RequiredAge2"]);
            /*ReactDOM.render(<MessageBox 
              Message={ Vas.Resources.Labels["RequiredAge3"] + result[1] + Vas.Resources.Labels["RequiredAge2"]} 
              Title={Vas.Resources.Titles["Note"]}
              
              />
                ,document.getElementById('messageContainer'));*/
            minValue = false;
          }else{
            minValue = true
          }
        }else{
          this.refs.dateOfBirth.setState({ MinValue: moment([maxBDay.year(),maxBDay.month(), maxBDay.date()]),
            FalseMinDateText: Vas.Resources.Labels["RequiredAge3"] + result[1] + Vas.Resources.Labels["RequiredAge2"] });
          minValue = true
        }
      }
      else{
        this.refs.dateOfBirth.setState({ MinValue:null,
          FalseMinDateText:"" });
        minValue = true
        this.refs.Order.setState({ usable : true });
      }

      if(maxValue === false || minValue === false){
        let mes = message.map(m=>{
          return(
            <div>{m}
            <br/></div>
          )
        })
        ReactDOM.render(<MessageBox 
          Message={ mes} 
          Title={Vas.Resources.Titles["Note"]}
          
          />
            ,document.getElementById('messageContainer'));
        this.refs.Order.setState({ usable : false });
      }
      else{
        this.refs.Order.setState({ usable : true });
      }
    }

    
    //#endregion

    //#region checkFields

    jumpTofirst(first,id){
      stepperIconActiveId =Jump.jump(this.state.steps,id,null,stepperIconActiveId,first);
      
    }

    checkFields(){
      
        if (this.state.requiredCeckBox){
            let count = 0;
            if(this.state.NoPayment === false){
              if(this.CustomerId === "00000"){
                count += this.state.requiredBankFields.length + this.state.requiredCeckBox.length;
              }else{
                count += this.state.requiredSelectField.length + this.state.requiredCeckBox.length;
              }
              
            }
            if (this.state.requiredConfirmationFields){
                count =+ this.state.requiredConfirmationFields.length ;
            } 
            
            if (this.state.requiredSelectField || this.state.requiredBankFields){
                let filled = 0;
                let result = [null,null];
                let first = null;

                if(this.state.NoPayment === false){
                  if(this.CustomerId === "00000"){
                    result = CheckFields.CheckTextFields(this.state.requiredBankFields);
                    filled+= result[0];
                    first = result[1];
                    if(this.state.CustomerEqualAccountOwner === false){
                      count += this.state.requiredFieldsAccountOwner.length + this.state.requiredSelectFieldsAccountOwner.length ;
              
                      result = CheckFields.CheckTextFields(this.state.requiredFieldsAccountOwner,first);
                      filled += result[0];
                      first = result[1];

                      result = CheckFields.CheckSelectFields(this.state.requiredSelectFieldsAccountOwner,first);
                      filled += result[0];
                      first = result[1];
                    }

                  }else{
                    result = CheckFields.CheckSelectFields(this.state.requiredSelectField);
                    filled+= result[0];
                    first = result[1];
                  }
                  

                  result = CheckFields.CheckCheckBox(this.state.requiredCeckBox,first);
                  filled+=result[0];
                  first = result[1];
                }
                              
                if (this.state.requiredConfirmationFields){
                  filled += CheckFields.CheckTextFields(this.state.requiredConfirmationFields)[0];
                }

                if(this.state.IamCustomer === false){
                  count += this.state.requiredCustomerFields.length + this.state.requiredCustomerSelectfields.length;
    
                  result =CheckFields.CheckTextFields(this.state.requiredCustomerFields,first);
                  filled += result[0];
                  first = result[1];

                  result = CheckFields.CheckSelectFields(this.state.requiredCustomerSelectfields,first);
                  filled += result[0];
                  first = result[1];
                }

                if(this.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
                  /*count++;
                      this.refs.email.setState({isrequired:true});
                      this.refs.emailRepeat.setState({isrequired:true});
                      if(this.state.EmailRepeat){
                        if(this.state.EmailRepeat === true){
                          filled++;
                        }
                      }*/
                }else{
                  
                  
                    if(this.Customer.Email.length > 0){
                      count++;
                      this.refs.email.setState({isrequired:true});
                      this.refs.emailRepeat.setState({isrequired:true});
                      
                      if(this.state.EmailRepeat){
                        if(this.state.EmailRepeat === true){
                          filled++;
                        }
                      }
                    }else{
                      this.refs.email.setState({isrequired:false});
                      this.refs.emailRepeat.setState({isrequired:false});
                    }
                  
                }
                
                let tariffingFilled = this.refs.Tariffing.checkFields();

                if (filled < count){
                    //this.refs.Order.setState({usable:false});
                    let step = 1;
                    if(tariffingFilled[0] === false){
                      first = tariffingFilled[1];
                      
                      let docs=document.querySelectorAll('select,input');
                      let docRefs = this.refs;
                      CheckValues.checkAllFields(docs,docRefs,"");
                      ReactDOM.render(<MessageBox 
                        Message={Vas.Resources.Labels["NotAllFields"]} 
                        Title={Vas.Resources.Titles["Note"]}
                        Click={()=>{
                          this.jumpTofirst(first,step); 
                          this.refs.Tariffing.goToFirstUnfilled();
                        }}
                        />
                          ,document.getElementById('messageContainer'));
                    }else{
                      
                      step =first.Step;
                      if(this.Customer.Email.length > 0){
                        if(this.state.EmailRepeat){
                          if(this.state.EmailRepeat === false){
                            step = 3;
                          }
                        }else{
                          step = 3;
                        }
                      }
                      let docs=document.querySelectorAll('select,input');
                      let docRefs = this.refs;
                      CheckValues.checkAllFields(docs,docRefs,"");
                      ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Labels["NotAllFields"]} 
                      Title={Vas.Resources.Titles["Note"]}
                      Click={()=>{
                        this.jumpTofirst(first,step); 
                      }}
                      />
                        ,document.getElementById('messageContainer'));
                    }
                    
                    
                    return false;
                } else {
                  
                  if(tariffingFilled[0] === true){
                    if (this.state.allCertificates === true){
                      //this.refs.Order.setState({usable:true});
                      return true;
                    }else{
                      if(this.state.IamCustomer === false){
                        if(localStorage.getItem('vas_role') === '3'){
                          this.jump(5);
                        }else{
                          this.jump(6);
                        }
                        
                      }else{
                        if(localStorage.getItem('vas_role') === '3'){
                          this.jump(3);
                        }else{
                          this.jump(4);
                        }
                      }
                      ReactDOM.render(<MessageBox 
                        Message={Vas.Resources.Labels["NotAllConfirmations"]} 
                        Title={Vas.Resources.Titles["Note"]} />
                          ,document.getElementById('messageContainer'));
                      return false;
                    }
                  }else{
                    ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Labels["NotAllFields"]} 
                      Title={Vas.Resources.Titles["Note"]}
                      Click={()=>{
                        this.jumpTofirst(tariffingFilled[1],1); 
                      }}
                      />
                        ,document.getElementById('messageContainer'));
                    return false;
                  }
                }
            }
        }
    }

    checkEmail(field) //Überprüft ob die wiederholte E-Mail-Adresse gleich der eingegebenen ist 
    {
      if(field === "Customer"){
        if($('#Email').val().length > 0 && $('#EmailRepeat').val().length > 0){
          if ($('#Email').val().toLowerCase() ===  $('#EmailRepeat').val().toLowerCase())
          {
            if(this.refs.email.getValid() === true ){
              this.refs.IconMailRepeat.setState({ Name:"Done", Color:"green" });
              this.setState({ EmailRepeat: true });
            }else{
              this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
              this.setState({ EmailRepeat: false });
              $('#EmailRepeat').val('');
              ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Id={"MessageBox"}
                  Title={Vas.Resources.Labels["Order"]}
                  Message={Vas.Resources.Tooltips["Email"]}
                  Field={"EmailRepeat"}
                  />
              , document.getElementById('messageContainer'));
            }
          }
          else
          {
            this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
            this.setState({ EmailRepeat: false });
            $('#EmailRepeat').val('');
            ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Id={"MessageBox"}
                Title={Vas.Resources.Labels["Order"]}
                Message={Vas.Resources.Labels["EmailRepeatNotValid"]}
                Field={"EmailRepeat"}
                />
                , document.getElementById('messageContainer'));
          }
        }else{
          this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
          this.setState({ EmailRepeat: false });
        }
      }
    }

    checkPayments(values){

      if(localStorage.getItem('vas_role') === '3'){
        if(this.CustomerId !== null && this.CustomerId !== undefined){
          if(Number(values[5]) > 0){
            if(this.CustomerId === "00000"){
            }else{
              if(this.state.Payments.length === 0){
                this.refs.Tariffing.returnTariffProduct();
                Vas.GetView("NoPayment", { CustomerId: this.CustomerId, NewContract : "true" }, true);
              }
            }
            this.setState({NoPayment : false },()=>{
              let rqBankfields = [
                {Key:this.refs.accountOwnerName, Index:20,Step:3},
                {Key:this.refs.accountOwnerFirstName, Index: 21, Step: 3},
                {Key:this.refs.dateOfBirthAccountOwner,Index:22,Step:3}, 
                {Key:this.refs.iban ,Index: 31,Step:3},
                {Key:this.refs.bic ,Index: 32,Step:3}
              ];
              let rqSelctfiels = [{Key:this.refs.Payment,Index:20,Step:3}];
              this.setState({requiredSelectField : rqSelctfiels, requiredBankFields : rqBankfields},()=>{
                this.changeRequiredFieldsIndex(this.state.requiredBankFields,false,this.state.CertificateRequired);
              });
              this.Update("Payment");
            });
          }else{
           this.setState({NoPayment : true });
          }
        }
      }
    }

    checkIban() // Überprüft ob die eingegebene Iban valide ist
    {
      let me = this;
      this.refs.nameOfBank.setState({ Icon:"Loop" });

      let valid = this.refs.iban.getValid();
      if (valid[0] === true){
        if (valid[1]){
          me.refs.nameOfBank.setState({ Icon:'',Value:valid[1],editable:false });
          me.refs.bic.setState({ Value:valid[2],editable:false },()=>{
            this.checkBic();
          });
          
          this.Payment.Iban = $('#iban').val();
          this.Payment.BankName = valid[1];
          
          this.setState({ PaymentDataValid:true });
        } else {
          $("#nameOfBank").val('');
          $("#bic").val('');
          me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
          me.refs.bic.setState({ Value:null,editable:true },()=>{
            this.checkBic();
          });

          this.Payment.Iban = $('#iban').val();
          this.Payment.BankName = '';
          this.Payment.Bic = '';

          this.setState({ PaymentDataValid:true });
        }
      } else {
        $("#iban").val('');
        $("#nameOfBank").val('');
        $("#bic").val('');
        me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:false });
        me.refs.bic.setState({ Value:null,editable:false },()=>{
          this.checkBic();
        });

        this.Payment.Iban = '';
        this.Payment.BankName = '';
        this.Payment.Bic = '';

        me.setState({ PaymentDataValid:false });
      }

    }

    checkBic(){
        let bic = $("#bic").val();
        if (bic.length === 11||bic.length === 8){
            this.refs.IconBic.setState({ Name:"Done",Color:"green" });
            this.Payment.Bic = $("#bic").val();
            
        } else {
            this.refs.IconBic.setState({ Name:"Warning",Color:"red" });
            $("#bic").val('');
        }
    }
//#endregion
  
    //#region get data
    GetCustomer(){
     
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
        this.refs.Order.setState({ usable:false });
        this.Request.setErrorHandler(()=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Customer.Street = this.Customer.Street == "" ? $("#Street").val() : this.Customer.Street;

        if(this.CustomerId === "00000" &&localStorage.getItem("vas_role") === "3"){
          this.CustomerModel.Customer = this.Customer;
          this.CustomerModel.Customer.ClientId = this.AccountsModel.Customer.ClientId;
          if(this.ChosenTariff != ''){
            let tariff = this.ChosenTariff;
            this.CustomerModel.InsertCustomerWithCustomerAbove(tariff[3]);
          }
          /*if($('#Company').val() != undefined) {
            this.CustomerModel.InsertCustomerWithCustomerAbove($('#Company').val());
          } else{
            this.CustomerModel.InsertCustomer();
          }*/
          //this.Update("Customer");
        }else {
          this.CustomerModel.GetCustomerById(this.CustomerId);
        }
        
    }

    getStreets(field)
    {
        let me = this;
        if( field === "Customer"){
          if (this.Customer.City && this.Customer.PostCode){
            me.refs.street.setState({ Icon:"Loop" });
            this.StreetsModel.GetStreets(encodeURI(this.Customer.City), this.Customer.PostCode);
          }
        }
        else if( field === "AccountOwner"){
          if (this.AccountOwner.City.length > 0 && this.AccountOwner.Zip.length > 0){
            me.refs.streetAccountOwner.setState({ Icon:"Loop" });
            me.StreetsModelAccountOwner.GetStreets(this.AccountOwner.City, this.AccountOwner.Zip);
          }
        }
    };

//#endregion

    Order()//Bestellen
    {

        let filled = this.checkFields();

        if ( filled === true){

            this.GetCustomer();
        }
    }

    //#region Confirmation
    getConfirmation(){ //hole alle Nachweise, die für den gewählten TariffPoint notwendig sind
      let tariff = this.refs.Tariffing.returnTariffProduct();
      this.ChosenTariff = tariff;
      if(tariff[0]!== null){
        if(tariff[0].IdTicket !== null && tariff[0].IdTicket !== undefined){
          if(ReactDOM.findDOMNode(document.getElementById('confirmationFields'))){
            ReactDOM.unmountComponentAtNode(document.getElementById('confirmationFields'));
          }
          if(ReactDOM.findDOMNode(document.getElementById("uploadFields"))){
              ReactDOM.unmountComponentAtNode(document.getElementById("uploadFields"));
          }
    
          $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
  
          this.Request.setErrorHandler(()=>{
            $("#LoadingIconPopUp").removeClass().addClass('hide');
          });
          this.ConfirmationsModel.GetConfirmationsByTicketId(tariff[0].IdTicket,this.CustomerBDay.DateOfBirth);
        }
      }
    }

    getConfirmationFields(Data){//hole alle zum Kunden gehörenden Nachweise und prüfe, ob die benötigten bereits vorhanden sind
      if (!Data){
        Data = this.state.Confirmation; 
      }
      let existConfirm = [];
      existConfirm = this.state.existConfirm;
      if (Data){
          let count = Data.length;
          let filled = 0;

          Data.map(C =>{
            for (let i = 0; i< existConfirm.length; i++){
                if (existConfirm[i] === C["Name"]){
                    filled++;
                }
            }
          });

          if (filled === count){
              this.setState({ allCertificates: true,Confirmation:Data});
          } else {
              this.setState({ allCertificates: false,Confirmation:Data});
          }
        }
    }

    setVerificationMonths(minValue,maxValue){
      let monthsArr = [Vas.Resources.Calendar["January"],Vas.Resources.Calendar["February"],Vas.Resources.Calendar["March"],Vas.Resources.Calendar["April"],
        Vas.Resources.Calendar["May"],Vas.Resources.Calendar["June"],Vas.Resources.Calendar["July"],Vas.Resources.Calendar["August"],
        Vas.Resources.Calendar["September"],Vas.Resources.Calendar["October"],Vas.Resources.Calendar["November"],Vas.Resources.Calendar["December"]];
      let months = [];
      if(document.getElementById('VerificationYear')){
        if(document.getElementById('VerificationYear').selectedIndex > 0){
          if(maxValue){
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              let count =monthsArr.length;
              if(year === maxValue.year()){
                count = maxValue.month()+1;
              }
              for(let i = firstMonth; i<count;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            
            else if(year === maxValue.year()){
              let lastMonth = maxValue.month();
              for(let i = 0; i<=lastMonth;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
            
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }else{
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              for(let i = firstMonth; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }
          
        }else{
          for(let i = 0; i<monthsArr.length;i++){
            months.push({Display:monthsArr[i],Key:i});
          }
        }
      }else{
        for(let i = 0; i<monthsArr.length;i++){
          months.push({Display:monthsArr[i],Key:i});
        }
      }
      
      return months;
    }

    getUploadFileds(C){// lege Felder für das hochladen eines Nachweises fest

        let from = <td></td>;
        let to =<td></td>;
        let id =<td></td>;
        let downloadDocumentButton = <div></div>;

        let btoUploadCertificate = true;
        
        let tariff = this.refs.Tariffing.returnTariffProduct();
        let minValue = DateTimeHelper.StringToDate(tariff[1].ContractStart,true,localStorage.getItem('vas_language'));
        
        //let minValue = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
        $('#uploadFields').removeClass().addClass('uploadFieldsVisible');
      
        if (C["DateFrom"] === true){
            from = (<td><DateField 
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")} 
              Width={200} 
              Editable={true} 
              IsRequired={true} 
              Id={"CertificateStart"} 
              Label={Vas.Resources.Labels["ValidFrom"]+ '*'}
              OnBlur={()=>{ this.setState({ CertificateStart: $("#CertificateStart").val() });}}
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              />
            </td>);
        }

        if (C["DateTo"] === true){
          if(C["MaxAge"] > 0){
            if(C["Name"].indexOf("Ermäßigung") > -1){

              /*to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ 
                  let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                  curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                  curDate = DateTimeHelper.FormatToShortDateString(curDate);
                  
                  this.setState({ CertificateEnd: curDate });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                ShowDay={false}
                /></td>);*/
              let countYears = 1 ;
              if(minValue.month() > 0){
                countYears = 2;
              }
              let maxValue = null;
              if(this.CustomerBDay.DateOfBirth.length > 0){
                
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                //countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
                if(maxValue.year() === minValue.year()){
                  countYears = 1;

                }else{
                  if(maxValue.isAfter(moment([minValue.year() + 1,minValue.month(),minValue.date()]))){
                    maxValue = moment([minValue.year() + 1,minValue.month()-1,minValue.date()]);
                   }
                }
                
              }else{
                maxValue = moment([minValue.year() + 1,minValue.month() -1,minValue.date()]);
              }
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<countYears; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);

            }else if(C["Name"] === "vsl. Ende der Ausbildung"){
              let countYears = 10 ;
              let maxValue = null;
              if(this.CustomerBDay.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              }
              
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<countYears; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);
            }
            else{
              let countYears = 10 ;
              let maxValue = null;
              if(this.CustomerBDay.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerBDay.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              }else{

              }
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={maxValue ? moment([maxValue.year(),maxValue.month(),maxValue.date()]).subtract(1,"day") : null}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                /></td>);
            }
          }else{
            if(C["Name"].indexOf("Ermäßigung") > -1){
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ 
                  let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                  curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                  curDate = DateTimeHelper.FormatToShortDateString(curDate);
                  
                  this.setState({ CertificateEnd: curDate });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                ShowDay={false}
                /></td>);

            }
            else if(C["Name"] === "vsl. Ende der Ausbildung"){
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<10; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);
            }
            else{
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                /></td>);
            }
          }
        }

        if (C["IdentificationNumber"] === true){
            id = (<td colSpan={2}>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Width={220} 
                Id="IDField" 
                Editable={true} 
                IsRequired={true}  
                Label={Vas.Resources.Labels["IdentificationNumber"]+ '*'} 
                OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IDField").val() });}} />
            </td>);
        }

        if(C["Name"].indexOf("Ermäßigung") > -1){
          downloadDocumentButton = (<div><ExtendedButton
              Id={"DownloadDocument"}
              Usable={true}
              Text={ Vas.Resources.Labels["ReductionDocumentDownload"] }
              Width={170}
              Float={"left"}
              OnClick={() => { window.open(Vas.ApplicationUrl+"/ErmäßigungABO.pdf") }} /></div>);
        }
        
        let FileText;

        var kontrastNumber = localStorage.getItem('Kontrast');
  
        let btoChooseIcon = <ExtendedButton 
                Id={"btoChoose"} 
                Usable={true} 
                Text={<Icon  
                  Name={"Upload"} 
                  Size={18} 
                  Color={"black"} 
                  PaddingLeft={'6px'} 
                  PaddingTop={'0px'} 
                  Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />} 
                Width={30} 
                Height={30}
                Type={"Round"}
                OnClick={()=>{$("#fileUpload").trigger('click');}}
                 />;

        if(Vas.isIE){
          btoChooseIcon = <ExtendedButton 
                Id={"btoChoose"} 
                Usable={true} 
                Text={<Icon  
                  Name={"Upload"} 
                  Size={18} 
                  Color={"black"} 
                  PaddingLeft={'6px'} 
                  PaddingTop={'0px'} 
                  Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />} 
                Width={30} 
                Height={30} 
                Type={"Round"}/>;
        }
      
        let btoChooseText = "";
        if(this.IconConfig.ShowIcons === false){
          btoChooseIcon="";

          var kontrastNumber = localStorage.getItem('Kontrast');
  
          if(kontrastNumber == "true"){
            btoChooseText = <ExtendedButton
                    Id={"btoChoose"}
                    Usable={true}
                    Text={Vas.Resources.Labels["ChooseDocument"]}
                    Width={150}
                    BackgroundColor={"#1d5c87"} 
                    OnClick={()=>{$("#fileUpload").trigger('click');}} />;

          if(Vas.isIE){
            btoChooseText = <ExtendedButton
                    Id={"btoChoose"}
                    Usable={true}
                    Text={Vas.Resources.Labels["ChooseDocument"]}
                    Width={150} 
                    BackgroundColor={"#1d5c87"} />;
          }
          } else{
            btoChooseText = <ExtendedButton
                    Id={"btoChoose"}
                    Usable={true}
                    Text={Vas.Resources.Labels["ChooseDocument"]}
                    Width={150}
                    OnClick={()=>{$("#fileUpload").trigger('click');}} />;

          if(Vas.isIE){
            btoChooseText = <ExtendedButton
                    Id={"btoChoose"}
                    Usable={true}
                    Text={Vas.Resources.Labels["ChooseDocument"]}
                    Width={150} />;
          }
          }
        }

        let hint = "";
        if(C["Description"].length > 0){
          hint = <div><b>{Vas.Resources.Titles["Note"]}: </b><i>{C["Description"]}</i></div>;
        }

        let classNameStandartControl = "standartInput";
        let additionTextField = <td></td>;
        let additionButton = <td></td>;

        var kontrastNumber = localStorage.getItem('Kontrast');

        if(this.UploadConfig.ShowStandardControl === false){

          classNameStandartControl = "inputfile";

          additionButton = <td colSpan={2}>
            <label htmlFor="fileUpload">
                {btoChooseText}
                
                </label>
            </td>

          if(kontrastNumber == "true"){
            additionTextField = <td style={{ width:'170px' }}>
            <TextField 
              AppURL={Vas.ApplicationUrl} 
              //ref={insp=>{FileText = insp;}} 
              ref={this.FileText}
              Width={170} 
              Id="FileText" 
              Value={this.state.fileName} 
              Editable={false}  
              BorderBottom={ '1px dotted #1d5c87'}
              Label={Vas.Resources.Labels["File"]+ '*'} />
            </td>           
          } else {
            additionTextField = <td style={{ width:'170px' }}>
            <TextField 
              AppURL={Vas.ApplicationUrl} 
              //ref={insp=>{FileText = insp;}} 
              ref={this.FileText}
              Width={170} 
              Id="FileText" 
              Value={this.state.fileName} 
              Editable={false}  
              Label={Vas.Resources.Labels["File"]+ '*'} />
            </td>
          }

        }

        let uploadCertificateButton = "";
        let textField = "";
  
      if(kontrastNumber == "true"){
        uploadCertificateButton = (<ExtendedButton
          Id={"uploadCertificate"}
          Usable={btoUploadCertificate} 
          Text={Vas.Resources.Labels["UploadCertificate"]} 
          Float={"left"} 
          Width={170} 
          BackgroundColor={"#1d5c87"} 
          OnClick={()=>{this.uploadDocument(C);}}
          ref={this.UploadCertificateRef} /> );

          textField = (<TextField 
            AppURL={Vas.ApplicationUrl} 
            Value={C["Name"]} 
            Width={220} 
            Id={"Text"} 
            Editable={false}  
            BorderBottom={ '1px dotted #1d5c87'}
            Label={Vas.Resources.Labels["CertificationType"]} />);
      } else{
        uploadCertificateButton = (<ExtendedButton
          Id={"uploadCertificate"}
          Usable={btoUploadCertificate} 
          Text={Vas.Resources.Labels["UploadCertificate"]} 
          Float={"left"} 
          Width={170} 
          OnClick={()=>{this.uploadDocument(C);}}
          ref={this.UploadCertificateRef} /> );

          textField = (<TextField 
            AppURL={Vas.ApplicationUrl} 
            Value={C["Name"]} 
            Width={220} 
            Id={"Text"} 
            Editable={false}
            Label={Vas.Resources.Labels["CertificationType"]} />);
      }

        ReactDOM.render(
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      { textField}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <div id={"Headline"} style={{ margin: '10px' }}>{hint}</div>

                      { downloadDocumentButton }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tbody>
                          <tr>
                            <td className={"btoTd"} style={{paddingTop:'42px'}}>
                              <input 
                                id="fileUpload" 
                                type="file" 
                                name="files[]" 
                                className={classNameStandartControl} 
                                onChange={(event)=>{this.storeFile(event,C);}} 
                                accept="image/bmp,image/png,image/jpeg,image/jpg, image/gif,application/pdf" />
                              <label htmlFor="fileUpload">{btoChooseIcon}
                              </label>
                            </td>
                            {additionTextField}
                            
                          </tr>
                          <tr>
                            {additionButton}
                            
                          </tr>
                        </tbody>
                      </table>
                    </td>
                                
                  </tr>
                  <tr>
                    {from}
                                
                  </tr>
                  <tr>
                    {to}
                  </tr>
                  <tr>
                    {id}
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <br />{Vas.Resources.Labels["ValidDocumentFormat"]}
                      <br /><br />{Vas.Resources.Labels["ValidDocumentSize"]}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {uploadCertificateButton}  
                    </td>
                  </tr> 
                </tbody>
              </table>
            , document.getElementById('uploadFields'));

            this.setState({ FileText:FileText });
    }

    storeFile(event,C){//Speichere Dokument in der Anwendung
        let type = event.target.files[0].type;
        if (((type.slice(0,5) === "image") || (type === "application/pdf")) && (event.target.files[0].size > 0) ){

          let maxFileSize = 10 * 1024 * 1000;

              if (event.target.files[0].size > maxFileSize){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Message={Vas.Resources.Labels["DocumentSizeInvalid"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    , document.getElementById('messageContainer'));

                    this.FileText.current.setState({ Value:'', TextTooltip : '' });
                    this.setState({ files:null, fileName:''});
              } else {

                let original = event.target.files[0].name;
                let name = event.target.files[0].name.split(".");

                if(name.length === 2){
                  let length = name[0].length;
                  let showName = name[0];
                  let showType = "." + name[1];
                  if(length > 20){
                  showName = name[0].substr(0,19) + "...";
                  }
                  original = showName + showType;
                }
                if(this.UploadConfig.ShowStandardControl === false){
                this.FileText.current.setState({ Value:original, TextTooltip : event.target.files[0].name });
                }
                  this.setState({ files:event.target.files, fileName:event.target.files[0].name },()=>{
                      this.getUploadFileds(C);
                  }); 
              }
        }else{
          if(event.target.files[0].size === 0){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["FileNoContent"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          }
        }
    }

    uploadDocument(field){//lade Nachweis in die Datenbank hoch

        let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
        let start = curContractStart;

        let ok = false;
        let falseDate = false;

        let dateFrom = null;
        let dateTo = null;
        let identificationNumber = null;
        let files = null;

        
        if (this.state.files){
            files = this.state.files;
            ok = true;
        }
        
        if (ok === true){
            if (field.DateFrom === true){
                if (this.state.CertificateStart){
                    let cur = DateTimeHelper.StringToDate(this.state.CertificateStart,false,localStorage.getItem('vas_language'));
                    let certStart =cur;

                    if (certStart.isSameOrBefore(start) === true){
                      dateFrom = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                      ok = true; 
                    } else {
                      ok = false;
                      falseDate = true;
                    }
                } else {
                    ok = false;
                }
            }
        }
        
        if (ok === true){
            if (field.DateTo === true){
                if (this.state.CertificateEnd){
                    let cur = DateTimeHelper.StringToDate(this.state.CertificateEnd,false,localStorage.getItem('vas_language'));
                    let certEnd = cur;

                    if (certEnd.isSameOrAfter(start) === true){
                      dateTo = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                      ok = true;
                    } else {
                        ok = false;
                        falseDate = true;
                    }
                } else {
                    ok = false;
                }
            }
        }
        
        if (ok === true){
            if (field.IdentificationNumber === true){
                if (this.state.IdentificationNumber){
                    identificationNumber = this.state.IdentificationNumber;
                    ok = true;
                } else {
                    ok = false;
                }
            }
        }
        
        
        if (ok === true){
          this.setState({field : field.Name},()=>{
            if(this.CustomerId === "00000" && localStorage.getItem('vas_role') === "3"){
              let exist = []; 
              exist = this.state.existConfirm;
              exist.push(this.state.field);

              let data = {
                file : files,
                confirmationId :field.Ident,
                datefrom : dateFrom,
                dateto : dateTo,
                identificationNumber : identificationNumber
              };

              let curFiles = this.state.Files;
              curFiles.push(data);
              this.setState({Files: curFiles, field: null, existConfirm:exist,CertificationType:null,CertificateStart:null,CertificateEnd:null,IdentificationNumber:null,requiredFieldsCertificate:null, files:null, fileName:'' });
              $('#uploadFields').removeClass().addClass('uploadFields');
              ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
              this.getConfirmationFields();
              
              
            }else{
              this.ConfirmationsModel.UploadConfirmation(this.CustomerId,field.Ident,dateFrom,dateTo,identificationNumber,files);
            }
             
          })
            
        } else {
            if (falseDate === true){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Title={Vas.Resources.Titles["Note"]} 
                  Message={Vas.Resources.Labels["FalseDate"]} />
                    , document.getElementById('messageContainer'));
            } else {
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Title={Vas.Resources.Titles["Note"]} 
                  Message={Vas.Resources.Labels["NotAllFields"]} />
                    , document.getElementById('messageContainer'));
            }
        }
    }
    //#endregion

    //#region steps

    setStepTariffing(){
      
      var motiv1Image = <input type={"radio"} id={"Motiv1"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} onClick={() =>{this.handleChange();}} />;
      var motiv2Image = <input type={"radio"} id={"Motiv2"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} onClick={() =>{this.handleChange();}} />;
      var motiv3Image = <input type={"radio"} id={"Motiv3"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} onClick={() =>{this.handleChange();}} />;

      if(localStorage.getItem("SelectedMotiv") != null){
        if(localStorage.getItem("SelectedMotiv") == 1){
          motiv1Image = <input type={"radio"} id={"Motiv1"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} checked={true} onClick={() =>{this.handleChange();}} />;
        } else if(localStorage.getItem("SelectedMotiv") == 2){
          motiv2Image = <input type={"radio"} id={"Motiv2"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} checked={true} onClick={() =>{this.handleChange();}} />;
        } else if(localStorage.getItem("SelectedMotiv") == 3){
          motiv3Image = <input type={"radio"} id={"Motiv3"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-65px'}} checked={true} onClick={() =>{this.handleChange();}} />;
        }

        localStorage.removeItem("SelectedMotiv");
      }

      return(
        <div>
          <table>
          <tbody>
            <tr>
              <td>
                <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr><td>
              
            <div id={"TermsOfUsage"} className={"termsOfUsage"} >
              

            <div id={"ChooseDeutschlandTicket"} style={{display: 'none'}}> {Vas.Resources.Labels["GermanTicketChipCardHint"]} <br/><br/>
                      <div id="Deutschlandticket (Motiv1)" style={{marginBottom: '10px'}}>
                        <div style={{marginLeft: '90px'}}>Motiv 1</div>
                        {motiv1Image}
                        <img src="../../images/tariff/Motiv1.PNG" name="Deutschland-Ticket (Motiv 1)" alt="Motiv1" style={{ width: '203.67px' }}/>
                      </div>
                      <div id="Deutschlandticket (Motiv2)" style={{marginBottom: '10px'}}>
                        <div style={{marginLeft: '90px'}}>Motiv 2</div>
                        {motiv2Image}
                        <img src="../../images/tariff/Motiv2.PNG" name="Deutschland-Ticket (Motiv 2)" alt="Motiv2" style={{ width: '203.67px' }}/>
                      </div>
                      <div id="Deutschlandticket (Motiv3)">
                        <div style={{marginLeft: '90px'}}>Motiv 3</div>
                        {motiv3Image}
                        <img src="../../images/tariff/Motiv3.PNG" name="Deutschland-Ticket (Motiv 3)" alt="Motiv3" style={{ width: '203.67px' }}/>
                      </div>
                    </div>

                      <table id="termsOfUsage"><tbody></tbody></table>
                    </div>

                 <TariffingProductsToPoints
                    ShowClientsBox={false}
                    ApplicationUrl={Vas.ApplicationUrl}
                    ApiKey={Vas.ApiKey}
                    ApiUrl={Vas.ApiUrl}
                    TimeOutTime={Vas.TimeOutTime}
                    ContractEndText={Vas.Resources.Labels["TermUntil"]}
                    MethodAfterProducts ={(value)=>{this.checkPayments(value); }}
                    ConfigDefaults={Vas.Config.Defaults}
                    ConfigContractEnd = {Vas.Config.ContractEnd}
                    ErrorHandling={(error)=>{Vas.ErrorHandling(error)}}
                    MethodAfterTickets={(ticketId)=>{this.showRequiredAge(ticketId);}}
                    ContractId={this.ContractId}
                    CustomerId={this.CustomerId}
                    ShowPriceLevel={true}
                    ShowTariffPointIdent={false}
                    DeleteRelationTo={false}
                    FilteredProductIdents={"01-99-02;01-99-02;01-991-02;01-992-02;01-993-02"}
                  // Text={<div>
                  //     <br/>
                  //       {Vas.Resources.Labels["TextBärenTicketYoungTicket"]}
                  //       <br/><br/>
                  //       <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz1"]}</b>
                  //       {Vas.Resources.Labels["And2"]}
                  //       <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz2"]}</b>
                  //       </div>}
                    ref ={"Tariffing"}
                  />
                  {/*<TariffingPointsToProduct
                    ApplicationUrl={Vas.ApplicationUrl}
                    ApiKey={Vas.ApiKey}
                    ApiUrl={Vas.ApiUrl}
                    TimeOutTime={Vas.TimeOutTime}
                    Text={<div>
                        <br/>
                          {Vas.Resources.Labels["TextBärenTicketYoungTicket"]}
                          <br/><br/>
                          <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz1"]}</b>
                          {Vas.Resources.Labels["And2"]}
                          <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz2"]}</b>
                          </div>}
                          ref ={"Tariffing"}

                    ContractEndText={Vas.Resources.Labels["TermUntil"]}
                    />*/}
            </td></tr>
          </tbody>
        </table>
        </div>
      );
    }

    setStepperCustomer(){
      return(
        <table style={{ width: '375px'}}>
          <tbody>
            <tr>
              <td>
              <Checkbox
                ref={"IamCustomer"}
                Id={"checkboxIamCustomer"}
                onClick={()=>{
                  document.getElementById("checkboxIamCustomer").checked = true;
                  document.getElementById("checkboxIamNotCustomer").checked = false;
                  
                  let rqSelectField = this.state.requiredSelectField;
                  let rqCheckBox = this.state.requiredCeckBox;
                  rqSelectField = this.changeRequiredFieldsIndex(rqSelectField,true,this.state.ConfirmationsRequired);
                  rqCheckBox = this.changeRequiredFieldsIndex(rqCheckBox,true,this.state.ConfirmationsRequired);
                  this.setState({ IamCustomer:true,
                    requiredSelectField: rqSelectField,
                    requiredCeckBox: rqCheckBox });}} />
              </td>
              <td>
                  <div className={"HintContractStart2"}>{Vas.Resources.Labels["IamCustomer"]}</div>
              </td>
            </tr>
            <tr>
              <td>
              <Checkbox
                ref={"IamNotCustomer"}
                Id={"checkboxIamNotCustomer"}
                onClick={()=>{
                  document.getElementById("checkboxIamCustomer").checked = false;
                  document.getElementById("checkboxIamNotCustomer").checked = true;

                  let rqSelectField = this.state.requiredSelectField;
                  let rqCheckBox = this.state.requiredCeckBox;
                  rqSelectField = this.changeRequiredFieldsIndex(rqSelectField,false,this.state.ConfirmationsRequired);
                  rqCheckBox = this.changeRequiredFieldsIndex(rqCheckBox,false,this.state.ConfirmationsRequired);

                  this.setState({ IamCustomer:false,
                    requiredSelectField: rqSelectField,
                    requiredCeckBox: rqCheckBox });}} />
              </td>
              <td>
              <div className={"HintContractStart2"}>{Vas.Resources.Labels["IamNotCustomer"]}</div>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }

    setStepCustomerPersonal(){
      let emailRequired = false;
      let emailString = Vas.Resources.Labels["VoluntaryDisclosure"];
      if(this.CustomerId === "00000" && localStorage.getItem("vas_role") === "3"){
        //emailRequired = true;
        //emailString = "*";
      }
      
      

      let customersAbove = '';

      

      return(
        <table>
          <tbody>
          <tr>
            <td colSpan='2'>
              <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
            </td>
            <td></td>
          </tr>
            <tr>                          
              <td className={"LeftContainer"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Modus={"Name"}
                ref={"name"}
                IsRequired={true}
                Editable={true}
                Id={"Name1"}
                Label={Vas.Resources.Labels["Name"]+ "*"}
                OnChange={()=>{ this.Customer.Name1 = $("#Name1").val() }} /></td>
              <td className={"RightContainer"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Modus={"Name"}
                ref={"firstName"}
                IsRequired={true}
                Editable={true}
                Id={"Name2"}
                Label={Vas.Resources.Labels["FirstName"]+ "*"}
                OnChange={()=>{ this.Customer.Name2 = $("#Name2").val() }} /></td>
            </tr>
            <tr>
              <td className={"LeftContainer"}>
                <DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                me={this}
                Editable={true}
                ref={"dateOfBirth"}
                MaxValue={moment()}
                IsRequired={true}
                Id={"DateOfBirth"}
                Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                Label={Vas.Resources.Labels["DateOfBirth"]+ "*"}
                OnBlur={()=>{
                  if($("#DateOfBirth").val().length>0){
                    let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
                    let date = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00")
                    this.Customer.DateOfBirth = date;
                    this.CustomerBDay = this.Customer;
                    this.getConfirmation();
                  }
                  
                }}
                FalseMaxDateText={Vas.Resources.Labels["DateUnderTime"]}  /></td>
              <td className={"RightContainer"}>
                <SelectField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"gender"}
                IsRequired={true}
                Id={"Gender"}
                Label={Vas.Resources.Labels["Gender"]+ "*"}
                Data={ this.state.GenderValues }
                OnChange={()=>{ this.Customer.Gender = $("#Gender").val()}}
                Tooltip={Vas.Resources.Tooltips["Gender"]} /></td>
            </tr>
            <tr>
              <td colSpan="2">
                <EmailField
                AppURL={Vas.ApplicationUrl}
                ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error)}}
                me={this}
                Id={"Email"}
                ref={"email"}
                Editable={true}
                IsRequired={emailRequired}
                Tooltip={Vas.Resources.Tooltips["Email"]} 
                Label={Vas.Resources.Labels["Email"]+ emailString}
                //OnChange={()=>{this.setState({ Email: $("#Email").val() }); }}
                ApiUrl={Vas.ApiUrl}
                ApiKey={Vas.ApiKey}
                Token={localStorage.getItem["vas_token"]}
                AnonymousToken={localStorage.getItem["anonymous_token"]}
                OnBlur={()=>{
                  this.setState({ EmailRepeat: false },()=>{
                  this.Customer.Email = $("#Email").val(); 
                  document.getElementById('EmailRepeat').value = '';
                  this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
                }); }}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div id={"mailRepeat"}>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"emailRepeat"}
                          Editable={true}
                          IsRequired={emailRequired}
                          Id={"EmailRepeat"}
                          Label={Vas.Resources.Labels["EmailRepeat"]+ emailString}
                          //OnBlur={()=>{ this.checkEmail();}}
                          //OnChange={()=>{ this.setState({ EmailRepeat: $("#EmailRepeat").val() }); }} 
                          OnBlur={()=>{ this.setState({ EmailRepeatValue: $("#EmailRepeat").val() },()=>{this.checkEmail("Customer");}) }}
                          />
                          </div>
                      </td>
                      <td>
                        <Icon
                          Id={"iconMailRepeat"}
                          ref={"IconMailRepeat"}
                          Name={"Warning"}
                          Size={24}
                          Color={"red"}
                          Align={"left"} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td><TextField
                Modus={"TelNumber"}
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                ref={"phone"}
                Id={"Phone"}
                Label={Vas.Resources.Labels["Phone"]}
                OnChange={()=>{ this.Customer.Phone = $("#Phone").val() }} /></td>
            </tr>
            
          </tbody>
        </table>
      );
    }

    setStepCustomerAdress(){
      return(
        <table>
          <tbody>
          <tr>
            <td colSpan='2'>
              <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
            </td>
            <td></td>
          </tr>
            <tr>
              <td className={"LeftContainer"}>
                <TextField
                Modus={"Number"}
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"zip"}
                Id={"Zip"}
                IsRequired={true}
                Editable={true}
                Label={Vas.Resources.Labels["Zip"]+ "*"}
                OnBlur={()=>{ 

                  if ($("#Zip").val().length === 5){
                    this.Customer.PostCode = $("#Zip").val(); 
                  } else {
                    $("#Zip").val('');
                    ReactDOM.render(<MessageBox 
                      Message={Vas.Resources.Labels["PLZNote"]} 
                      Title={Vas.Resources.Titles["Note"]}
                      Field={"Zip"} />
                        ,document.getElementById('messageContainer'));
                  }
                }} /></td>
                <td className={"RightContainer"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"city"}
                  Id={"City"}
                  IsRequired={true}
                  Editable={true}
                  Label={Vas.Resources.Labels["Place"]+ "*"}
                  OnChange={()=>{ this.Customer.City = $("#City").val() }}
                  OnBlur={()=>{this.getStreets("Customer");}} /></td>
            </tr>
            <tr>
              <td colSpan={2}><AutocompleteField
                AppURL={Vas.ApplicationUrl}
                TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                me={this}
                Width={346}
                Modus={"Street"}
                IsRequired={true}
                ref={"street"}
                Id={"Street"}
                Float={'left'}
                editable={true}
                Label={Vas.Resources.Labels["Street"]+ "*"}
                Data={this.state.streets}
                OnBlur={()=>{this.Customer.Street = $("#Street").val()}}
                Tooltip={Vas.Resources.Tooltips["Street"]}
                TimeOutTime={Vas.TimeOutTime} /></td>
            </tr>
            <tr>
              <td className={"LeftContainer"}>
                <TextField
                Modus={"Number"}
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                ref={"houseNumber"}
                IsRequired={true}
                Id={"HouseNumber"}
                Label={Vas.Resources.Labels["HouseNumber"]+ "*"}
                OnChange={()=>{
                  this.Customer.HouseNumber = $("#HouseNumber").val(); 
                }} /></td>
              <td className={"RightContainer"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                ref={"houseNumberAddition"}
                Id={"HouseNumberAddition"}
                Label={Vas.Resources.Labels["HouseNumberAddition"]}
                OnChange={()=>{ this.Customer.HouseNumberAddition = $("#HouseNumberAddition").val()  }} /></td>
            </tr>
            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                Width={346}
                ref={"adressAddition"}
                Id={"AddressAddition"}
                Label={Vas.Resources.Labels["AdditionAdress"]}
                OnChange={()=>{ this.Customer.Name3 = $("#AddressAddition").val(); }} /></td>
            </tr>
          </tbody>
        </table>
      );
    }

    setStepVerifications(){
      
      let Data ='';
      if (!this.state.RequiredConfirmations){
        Data = this.state.Confirmation; 
      }else{
        Data =this.state.RequiredConfirmations;
      }
      let existConfirm = [];
      existConfirm = this.state.existConfirm;

      if(Data){

        let perso;
        let bank;
        let restData = [];

        Data.forEach(function(value){
          if(value.Name == "Personalausweis"){
            perso = value;
          }
          else if(value.Name == "Bankverbindungsnachweis"){
            bank = value;
          } else{
            restData.push(value);
          }
        });

        //Data leeren
        Data = [];

        //Perso und Bankverbindung in Data schreiben, wenn vorhanden
        if(perso != undefined){
          Data.push(perso);
        }

        if(bank != undefined){
          Data.push(bank);
        }

        //restlichen Nachweise in Data schreiben
        restData.forEach(function(value){
          Data.push(value);
        });

        return (
          <table style={{ width: '375px'}}>
            <tbody>
            <tr>
              <td colSpan='2'>
                <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
              </td>
              <td></td>
            </tr>
              <tr>
                <td id={"confirmationFields"}>
                <table>
                  <tbody>
                    {
                          Data.map(C =>{
                              let exist = false;
                              for (let i = 0; i< existConfirm.length; i++){
                                  if (existConfirm[i] === C["Name"]){
                                      exist = true;
                                  }
                              }
                              
                              if (exist === true){
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                              <td>
                                                <Icon
                                                  Name={"Done"}
                                                  Size={24}
                                                  Color={"green"}
                                                  Align={"left"}
                                                  Tooltip={Vas.Resources.Tooltips["StillUploaded"]} />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              } else {
                                let notUploaded = <Icon
                                Name={"Warning"}
                                Size={24}
                                Color={"red"}
                                Align={"left"}
                                OnClick={()=>{this.getUploadFileds(C);}}
                                Tooltip={Vas.Resources.Tooltips["NotUploaded"]} />;
                              if(this.IconConfig.ShowIcons === false){
                                    notUploaded = <ExtendedButton
                                    Id={"btoChooseDocument"}
                                    Usable={true}
                                    Text={Vas.Resources.Labels["UploadDocument"]}
                                    Width={150}
                                    OnClick={()=>{this.getUploadFileds(C);}}
                                />;
                              }
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                              {notUploaded}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              }
                          }) 
                          }
                  </tbody>
                </table>
                </td>
              </tr>
              <tr>
                <td
                  className={"uploadFields"}
                  id={"uploadFields"} >
                </td>
              </tr>
            </tbody>
          </table>
        );
      } else {
        return( <table></table>);
      }     
    }

    setStepperPayment(){

      var product = document.getElementById('TariffProducts');
      if(product != null){
        let productArray = product.value.split(";");
        console.log(productArray);
          let share1 = productArray[5];
          let share2 = productArray[6];

          if(share1 == 0 && share2 == 100){
            this.state.NoPayment = true;
          } else {
            this.state.NoPayment = false;
          }
      }

      if(this.state.NoPayment === false){
        if(this.CustomerId === "00000"){
          let address = <tr></tr>;
          if(this.state.CustomerEqualAccountOwner === false){

            
            address = <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className={"LeftContainer"}>
                          <SelectField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"genderAccountOwner"}
                            IsRequired={true}
                            Id={"GenderAccountOwner"}
                            Label={Vas.Resources.Labels["Gender"]+ "*"}
                            Data={ this.state.GenderValues }
                            OnChange={()=>{ this.AccountOwner.Gender = $("#GenderAccountOwner").val()}}
                            Tooltip={Vas.Resources.Tooltips["Gender"]} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='2'>
                        <div className={"LeftContainer"}>
                          <TextField
                          Modus={"Number"}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"zipAccountOwner"}
                          Id={"ZipAccountOwner"}
                          IsRequired={true}
                          Editable={true}
                          Label={Vas.Resources.Labels["Zip"]+ "*"}
                          OnBlur={()=>{ 

                            if ($("#ZipAccountOwner").val().length === 5){
                              this.AccountOwner.Zip = $("#ZipAccountOwner").val(); 
                            } else {
                              $("#ZipAccountOwner").val('');
                              ReactDOM.render(<MessageBox 
                                Message={Vas.Resources.Labels["PLZNote"]} 
                                Title={Vas.Resources.Titles["Note"]}
                                Field={"ZipAccountOwner"} />
                                  ,document.getElementById('messageContainer'));
                            }
                          }} />
                        </div>
                        <div className={"RightContainerAccountOwner"} >
                            <TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"cityAccountOwner"}
                            Id={"CityAccountOwner"}
                            IsRequired={true}
                            Editable={true}
                            Label={Vas.Resources.Labels["Place"]+ "*"}
                            OnChange={()=>{ this.AccountOwner.City = $("#CityAccountOwner").val() ; }}
                            OnBlur={()=>{this.getStreets("AccountOwner");}} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}><AutocompleteField
                        AppURL={Vas.ApplicationUrl}
                        TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                        MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                        me={this}
                        Width={346}
                        Modus={"Street"}
                        IsRequired={true}
                        ref={"streetAccountOwner"}
                        Id={"StreetAccountOwner"}
                        Float={'left'}
                        editable={true}
                        Label={Vas.Resources.Labels["Street"]+ "*"}
                        Data={this.state.streets}
                        OnBlur={()=>{ this.AccountOwner.Street = $("#StreetAccountOwner").val();}}
                        Tooltip={Vas.Resources.Tooltips["Street"]}
                        TimeOutTime={Vas.TimeOutTime} /></td>
                    </tr>
                    <tr>
                      <td colSpan='2'>
                        <div className={"LeftContainer"}>
                          <TextField
                          Modus={"Number"}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Editable={true}
                          ref={"houseNumberAccountOwner"}
                          IsRequired={true}
                          Id={"HouseNumberAccountOwner"}
                          Label={Vas.Resources.Labels["HouseNumber"]+ "*"}
                          OnChange={()=>{
                            this.AccountOwner.HouseNumber = $("#HouseNumberAccountOwner").val(); 
                          }} /></div>
                        <div className={"RightContainerAccountOwner"} >
                          <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Editable={true}
                          ref={"houseNumberAdditionAccountOwner"}
                          Id={"HouseNumberAdditionAccountOwner"}
                          Label={Vas.Resources.Labels["HouseNumberAddition"]}
                          OnChange={()=>{ this.AccountOwner.HouseNumberAddition = $("#HouseNumberAdditionAccountOwner").val(); }} /></div>
                        </td>
                    </tr>
                    <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Editable={true}
                  Width={346}
                  ref={"adressAdditionAccountOwner"}
                  Id={"AddressAdditionAccountOwner"}
                  Label={Vas.Resources.Labels["AdditionAdress"]}
                  OnChange={()=>{ this.AccountOwner.Name3 = $("#AddressAdditionAccountOwner").val() ; }} /></td>
              </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          }
          return(
            <table style={{ width: '478px'}}>
              <tbody>
              <tr>
                <td colSpan='2'>
                  <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                </td>
                <td></td>
              </tr>
                <tr>
                  <td colSpan={2}><b><div className={"ConfirmationLabel"}>{Vas.Resources.Titles["Note"]}:</div></b> <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NotePayment"]}</div></td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className={"LeftContainer"}><TextField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      ref={"accountOwnerName"}
                      Id="accountOwnerName"
                      Editable={true}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["DepositorName"] +"*"}
                      OnChange={()=>{ this.AccountOwner.Name1 = $("#accountOwnerName").val() ; }} /></div>
                    <div className={"RightContainer"}><TextField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      ref={"accountOwnerFirstName"}
                      Id="accountOwnerFirstName"
                      Editable={true}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["DepositorFirstname"]+"*"}
                      OnChange={()=>{ this.AccountOwner.Name2 = $("#accountOwnerFirstName").val() ; }} /></div>
                  </td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <div >
                      <DateField
                        AppURL={Vas.ApplicationUrl}
                        Language={localStorage.getItem("vas_language")}
                        me={this}
                        Editable={true}
                        MaxValue={moment()}
                        IsRequired={true}
                        Id={"DateOfBirthAccountOwner"}
                        ref={"dateOfBirthAccountOwner"}
                        Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                        Label={Vas.Resources.Labels["DateOfBirth"]+"*"}
                        OnBlur={()=>{ 
                          let cur = DateTimeHelper.StringToDate($("#DateOfBirthAccountOwner").val(),false,localStorage.getItem('vas_language'));
                          this.AccountOwner.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00");
                          this.checkAccountOwner();
                        }}
                        FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} />
                    </div>
                  </td>
                </tr>
                {address}
                <tr>
                  <td colSpan={2}>
                    <IbanField
                    AppURL={Vas.ApplicationUrl}
                    ApiUrl={Vas.ApiUrl}
                    ApiKey={Vas.ApiKey}
                    Token={localStorage.getItem["vas_token"]}
                    AnonymousToken={localStorage.getItem["anonymous_token"]}
                    me={this}
                    ref={"iban"}
                    Id="iban"
                    Editable={true}
                    IsRequired={true}
                    Label={Vas.Resources.Labels["Iban"]+"*"}
                    OnBlur={()=>{this.checkIban();}} /></td><td></td>
                </tr>
                <tr>
                  <td colSpan={2}><TextField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"bic"}
                    Id="bic"
                    Editable={false}
                    IsRequired={true}
                    Label={Vas.Resources.Labels["Bic"]+"*"}
                    OnBlur={()=>{this.checkBic();}}
                    Tooltip={Vas.Resources.Tooltips["BicLength"]} /><Icon
                      ref={"IconBic"}
                      Name={"Warning"}
                      Size={24}
                      Color={"red"}
                      Align={"left"} /></td>
                </tr>
                <tr>
                  <td colSpan={2}><TextField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"nameOfBank"}
                    Id="nameOfBank"
                    Editable={false}
                    Label={Vas.Resources.Labels["NameOfBank"]+"*"}
                    OnBlur={()=>{ this.Payment.BankName = $("#nameOfBank").val();}} /></td>
                </tr>
                <tr>
                  <td colSpan={2} >
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <Checkbox
                              ref={"AcceptPaymentTerms"}
                              Id={"checkboxAcceptPaymentTerms"}
                              onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                          </td>
                          <td>
                            {/*<div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PaymentText"]}*</div>*/}
                            {/*<div className={"ConfirmationLabel"}><label htmlFor="cbox" ><a
                            href={Vas.ApplicationUrl+"/ErteilungSEPA.pdf"}
                            target="_blank"
                      rel="noopener noreferrer" >{Vas.Resources.Labels["SEPA"]}*</a> </label></div>*/}
                            <div id="confirmationLabelSepa" className={"ConfirmationLabel"}>{Vas.Resources.Labels["SEPA"]}*</div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <ExtendedButton
                              Id={"PaymentTerms"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ViewHere"] }
                              Width={170}
                              Float={"left"}
                              OnClick={() => { window.open(Vas.ApplicationUrl+"/ErteilungSEPA.pdf") }} />
                          </td>
                        </tr>
                    </tbody>
                  </table>
                  </td>
                </tr>
            </tbody>
            </table>
          );
        }else{
          
          return(
            <table>
              <tbody>
                <tr>
                  <td>
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}><b><div className={"ConfirmationLabel"}>{Vas.Resources.Titles["Note"]}:</div></b><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NotePayment"]}</div></td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <SelectField 
                      AppURL={Vas.ApplicationUrl} 
                      me={this} 
                      Width={340} 
                      ref={"Payment"} 
                      Id={"Payments"} 
                      Editable={true} 
                      IsRequired={true} 
                      Tooltip={Vas.Resources.Tooltips["Payment"]} 
                      Label={Vas.Resources.Labels["MethodOfPaymentCustomer"]+"*"} 
                      OnChange={()=>{this.setState({ Payment: $("#Payments").val() });}} />   
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <table>
                      <tbody>
                        <tr>
                          <td><Checkbox
                      ref={"AcceptPaymentTerms"}
                      Id={"checkboxAcceptPaymentTerms"}
                      onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} /></td>
                        
                          <td>
                            {/*<div className={"ConfirmationLabel"}><label htmlFor="cbox" ><a
                    href={Vas.ApplicationUrl+"/ErteilungSEPA.pdf"}
                    target="_blank"
          rel="noopener noreferrer" >{Vas.Resources.Labels["SEPA"]}*</a> </label></div>*/}
                              <div id="confirmationLabelSepa" className={"ConfirmationLabel"}>{Vas.Resources.Labels["SEPA"]}*</div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <ExtendedButton
                              Id={"PaymentTerms"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ViewHere"] }
                              Width={170}
                              Float={"left"}
                              OnClick={() => { window.open(Vas.ApplicationUrl+"/ErteilungSEPA.pdf") }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    {/*<div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PaymentText"]}*</div>*/}
                    
                  </td>
                </tr>
              </tbody>
            </table>
          );
        }
      }else if(this.state.NoPayment === true){
        return(
          <table>
            <tbody>
              <tr>
                <td>
                <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoPaymentNecessary"]}</div>
                </td>
              </tr>
            </tbody>
          </table>
        )
      }
    }

    // setStepperOrder(){
    //   return <table></table>
    // }

    setStepperFinishOrder(){

      let tariffProduct = '';
      let personalDataTicketOwner = '';
      let addressDataTicketOwner = '';
      let payment = '';

      let accountOwnerAdressData = '';

      stepIdPayment = 2;
    
      tariffProduct = (<table id={"TariffProduct"}>
        <tbody>
          <tr>
            <td colSpan={5}>
              <br/>
              <br/>
              <div id={"TariffProductHeadline"} style={{ width: '360px'}}>
                <b>{ Vas.Resources.Labels["TariffProduct"] }</b>
              </div>
              <br/>
              <br/>
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_TicketNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["ProductSelection"]}:</b></div>

                <div id={"TariffProduct_TicketName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>

              <div id={"TariffProduct_Empty"}></div>

              <div id={"TariffProduct_RightContainer"}>
                <div id={"TariffProduct_ContractStartHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["ContractStart"]}:</b></div>
            
                <div id={"TariffProduct_ContractStart"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>  
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_FromHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["From"]}:</b></div>

                <div id={"TariffProduct_DescriptionLongFrom"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>  
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_ToHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["To"]}:</b></div>

                <div id={"TariffProduct_DescriptionLongTo"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>  
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_TzViaLabel"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Via"]}:</b></div>

                <div id={"TariffProduct_TzViaText"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>  
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_PriceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["ProductPrice"]}:</b></div>
            
                <div id={"TariffProduct_Price"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_PriceLevelHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["PriceLevel"]}:</b></div>
            
                <div id={"TariffProduct_PriceLevel"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div id={"TariffProduct_LeftContainer"}>
                <div id={"TariffProduct_ContractEndHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["ContractEnd"]}:</b></div>

                <div id={"TariffProduct_ContractEnd"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
              </div>  
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <br/>
              <ExtendedButton
                Id={"TariffProduct_ButtonBack"}
                Usable={true}
                Text={ Vas.Resources.Labels["ChangeTariffProduct"] }
                Width={180}
                Float={"left"}
                OnClick={() => { this.jump((1), 0); }} />
            </td>
          </tr>

        </tbody>
      </table>);

      if(this.state.IamCustomer === false)
      {
        if(this.state.ConfirmationsRequired === true){
          
          personalDataTicketOwner = (<table id={"PersonalDataTicketOwner"}>
        <tbody>
              <tr>
                <td colSpan={5}>
                    <br/>
                    <br/>
                    <div id={"PersonalDataTicketOwnerHeadline"} style={{ width: '360px'}}>
                      <b>{ Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"PersonalDataTicketOwner_LeftContainer"}>
                    <div id={"PersonalDataTicketOwner_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                    <div id={"PersonalDataTicketOwner_Name1"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>

                  <div id={"PersonalDataTicketOwner_Empty"}></div>

                  <div id={"PersonalDataTicketOwner_RightContainer"}>
                    <div id={"PersonalDataTicketOwner_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                    <div id={"PersonalDataTicketOwner_Name2"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"PersonalDataTicketOwner_LeftContainer"}>
                    <div id={"PersonalDataTicketOwner_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                    <div id={"PersonalDataTicketOwner_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>

                  <div id={"PersonalDataTicketOwner_Empty"}></div>

                  <div id={"PersonalDataTicketOwner_RightContainer"}>
                    <div id={"PersonalDataTicketOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                    <div id={"PersonalDataTicketOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"PersonalDataTicketOwner_LeftContainer"}>
                    <div id={"PersonalDataTicketOwner_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>
                
                    <div id={"PersonalDataTicketOwner_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"PersonalDataTicketOwner_LeftContainer"}>
                    <div id={"PersonalDataTicketOwner_PhoneHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Phone"]}:</b></div>
                
                    <div id={"PersonalDataTicketOwner_Phone"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td colspan={5}>
                <br/>
                <ExtendedButton
                  Id={"PersonalDataTicketOwner_ButtonBack"}
                  Usable={true}
                  Text={ Vas.Resources.Labels["ChangePersonalDataLegalGuardian"] }
                  Width={430}
                  Float={"left"}
                  OnClick={() => { this.jump((3), 0); }} />
                </td>
              </tr>
        </tbody>
      </table>);

          addressDataTicketOwner = (<table id={"AddressDataTicketOwner"}>
          <tbody>
              <tr>
                <td colSpan={5}>
                    <br/>
                    <br/>
                    <div id={"AddressDataTicketOwnerHeadline"} style={{ width: '430px'}}>
                      <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"AddressDataTicketOwner_LeftContainer"}>
                    <div id={"AddressDataTicketOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                
                    <div id={"AddressDataTicketOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>

                  <div id={"AddressDataTicketOwner_Empty"}></div>

                  <div id={"AddressDataTicketOwner_RightContainer"}>
                    <div id={"AddressDataTicketOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                    <div id={"AddressDataTicketOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"AddressDataTicketOwner_LeftContainer"}>
                    <div id={"AddressDataTicketOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                    <div id={"AddressDataTicketOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"AddressDataTicketOwner_LeftContainer"}>
                    <div id={"AddressDataTicketOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>
                
                    <div id={"AddressDataTicketOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>

                  <div id={"AddressDataTicketOwner_Empty"}></div>

                  <div id={"AddressDataTicketOwner_RightContainer"}>
                    <div id={"AddressDataTicketOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>
                
                    <div id={"AddressDataTicketOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                <td>
                  <div id={"AddressDataTicketOwner_LeftContainer"}>
                    <div id={"AddressDataTicketOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                    <div id={"AddressDataTicketOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                  </div>  
                </td>
              </tr>
              <tr>
                  <td colspan={5}>
                  <br/>
                  <ExtendedButton
                    Id={"AddressDataTicketOwner_ButtonBack"}
                    Usable={true}
                    Text={ Vas.Resources.Labels["ChangeAddressDataLegalGuardian"] }
                    Width={420}
                    Float={"left"}
                    OnClick={() => { this.jump((4), 0); }} />
                  </td>
                </tr>
          </tbody>
      </table>);

          stepIdPayment = stepIdPayment + 3;

          if(this.state.NoPayment === true){
            payment = (
              <table id={"Payment"}>
                <tbody>
                <tr>
                  <td colSpan={3}>
                    <br/>
                    <br/>
                    <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                      <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                  </td>
                </tr>
                  <tr>
                    <td>
                    <div id={"Payment_NoPayment"} className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoPaymentNecessary"]}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          } else{
            
            if(document.getElementById('Payments') !== null) {
     
              payment = (<table id={"Payment"}>
                <tboyd>
                  <tr>
                    <td colSpan={3}>
                      <br/>
                      <br/>
                      <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"Payment_LeftContainer"}>
                        <div id={"Payment_PaymentHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}:</b></div>

                        <div id={"Payment_Payment"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>6</div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"Payment_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tboyd>
              </table>);
            } else{
              payment = (<table id={"PaymentData"}>
                  <tbody>
                    <tr>
                      <td colSpan={5}>
                          <br/>
                          <br/>
                          <div id={"PaymentDataHeadline"} style={{ width: '360px'}}>
                            <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                          </div>
                          <br/>
                          <br/>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_DepositorNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorName"]}:</b></div>

                          <div id={"PaymentData_DepositorName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>

                        <div id={"PaymentData_Empty"}></div>

                        <div id={"PaymentData_RightContainer"}>
                          <div id={"PaymentData_DepositorFirstnameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorFirstname"]}:</b></div>

                          <div id={"PaymentData_DepositorFirstname"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                          <div id={"PaymentData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_BicHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Bic"]}:</b></div>
                      
                          <div id={"PaymentData_Bic"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"Headline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>
                      
                          <div id={"PaymentData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                    <td colspan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"PaymentData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                  </tbody>
              </table>);

              if(this.state.CustomerEqualAccountOwner === false){
                accountOwnerAdressData = (<table id={"AddressDataAccountOwner"}>
                    <tbody>
                        <tr>
                          <td colSpan={5}>
                              <br/>
                              <br/>
                              <div id={"AddressDataAccountOwnerHeadline"} style={{ width: '430px'}}>
                                <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["AccountOwner"] }</b>
                              </div>
                              <br/>
                              <br/>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>

                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                            <td colspan={5}>
                            <br/>
                            <ExtendedButton
                              Id={"AddressDataAccountOwner_ButtonBack"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ChangeAddressDataAccountOwner"] }
                              Width={420}
                              Float={"left"}
                              OnClick={() => { this.jump((stepIdPayment), 0); }} />
                            </td>
                          </tr>
                    </tbody>
                  </table>);
              }
            }
          }
        } else{

          stepIdPayment = stepIdPayment + 3;

          personalDataTicketOwner = (<table id={"PersonalDataTicketOwner"}>
            <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"PersonalDataTicketOwnerHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PersonalDataTicketOwner_LeftContainer"}>
                      <div id={"PersonalDataTicketOwner_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                      <div id={"PersonalDataTicketOwner_Name1"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"PersonalDataTicketOwner_Empty"}></div>

                    <div id={"PersonalDataTicketOwner_RightContainer"}>
                      <div id={"PersonalDataTicketOwner_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                      <div id={"PersonalDataTicketOwner_Name2"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PersonalDataTicketOwner_LeftContainer"}>
                      <div id={"PersonalDataTicketOwner_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                      <div id={"PersonalDataTicketOwner_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"PersonalDataTicketOwner_Empty"}></div>

                    <div id={"PersonalDataTicketOwner_RightContainer"}>
                      <div id={"PersonalDataTicketOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                      <div id={"PersonalDataTicketOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PersonalDataTicketOwner_LeftContainer"}>
                      <div id={"PersonalDataTicketOwner_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>
                  
                      <div id={"PersonalDataTicketOwner_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PersonalDataTicketOwner_LeftContainer"}>
                      <div id={"PersonalDataTicketOwner_PhoneHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Phone"]}:</b></div>
                  
                      <div id={"PersonalDataTicketOwner_Phone"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td colspan={5}>
                  <br/>
                  <ExtendedButton
                    Id={"PersonalDataTicketOwner_ButtonBack"}
                    Usable={true}
                    Text={ Vas.Resources.Labels["ChangePersonalDataLegalGuardian"] }
                    Width={430}
                    Float={"left"}
                    OnClick={() => { this.jump((3), 0); }} />
                  </td>
                </tr>
          </tbody>
        </table>);
  
          addressDataTicketOwner = (<table id={"AddressDataTicketOwner"}>
          <tbody>
            <tr>
              <td colSpan={5}>
                  <br/>
                  <br/>
                  <div id={"AddressDataTicketOwnerHeadline"} style={{ width: '430px'}}>
                    <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                  </div>
                  <br/>
                  <br/>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AddressDataTicketOwner_LeftContainer"}>
                  <div id={"AddressDataTicketOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
              
                  <div id={"AddressDataTicketOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>

                <div id={"AddressDataTicketOwner_Empty"}></div>

                <div id={"AddressDataTicketOwner_RightContainer"}>
                  <div id={"AddressDataTicketOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id={"AddressDataTicketOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>  
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AddressDataTicketOwner_LeftContainer"}>
                  <div id={"AddressDataTicketOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                  <div id={"AddressDataTicketOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>  
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AddressDataTicketOwner_LeftContainer"}>
                  <div id={"AddressDataTicketOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>
              
                  <div id={"AddressDataTicketOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>

                <div id={"AddressDataTicketOwner_Empty"}></div>

                <div id={"AddressDataTicketOwner_RightContainer"}>
                  <div id={"AddressDataTicketOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>
              
                  <div id={"AddressDataTicketOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>  
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AddressDataTicketOwner_LeftContainer"}>
                  <div id={"AddressDataTicketOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                  <div id={"AddressDataTicketOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                </div>  
              </td>
            </tr>
            <tr>
                <td colspan={5}>
                <br/>
                <ExtendedButton
                  Id={"AddressDataTicketOwner_ButtonBack"}
                  Usable={true}
                  Text={ Vas.Resources.Labels["ChangeAddressDataLegalGuardian"] }
                  Width={420}
                  Float={"left"}
                  OnClick={() => { this.jump((4), 0); }} />
                </td>
              </tr>
        </tbody>
        </table>);
  
          if(this.state.NoPayment === true){
            payment = (
              <table id={"Payment"}>
                <tbody>
                <tr>
                  <td colSpan={3}>
                    <br/>
                    <br/>
                    <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                      <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                  </td>
                </tr>
                  <tr>
                    <td>
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoPaymentNecessary"]}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          } else{
            if(document.getElementById('Payments') !== null) {

              payment = (<table id={"Payment"}>
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      <br/>
                      <br/>
                      <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"Payment_LeftContainer"}>
                        <div id={"Payment_PaymentHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}:</b></div>
                    
                        <div id={"Payment_Payment"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>6</div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"Payment_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tbody>
              </table>);
            } else{
              payment = (<table id={"PaymentData"}>
                  <tbody>
                    <tr>
                      <td colSpan={5}>
                          <br/>
                          <br/>
                          <div id={"PaymentDataHeadline"} style={{ width: '360px'}}>
                            <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                          </div>
                          <br/>
                          <br/>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_DepositorNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorName"]}:</b></div>

                          <div id={"PaymentData_DepositorName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>

                        <div id={"PaymentData_Empty"}></div>

                        <div id={"PaymentData_RightContainer"}>
                          <div id={"PaymentData_DepositorFirstnameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorFirstname"]}:</b></div>

                          <div id={"PaymentData_DepositorFirstname"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                          <div id={"PaymentData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_BicHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Bic"]}:</b></div>
                      
                          <div id={"PaymentData_Bic"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>
                      
                          <div id={"PaymentData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                    <td colspan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"PaymentData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                  </tbody>
              </table>);

              if(this.state.CustomerEqualAccountOwner === false){
                accountOwnerAdressData = (<table id={"AddressDataAccountOwner"}>
                  <tbody>
                        <tr>
                          <td colSpan={5}>
                              <br/>
                              <br/>
                              <div id={"AddressDataAccountOwnerHeadline"} style={{ width: '430px'}}>
                                <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["AccountOwner"] }</b>
                              </div>
                              <br/>
                              <br/>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>

                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                            <td colspan={5}>
                            <br/>
                            <ExtendedButton
                              Id={"AddressDataAccountOwner_ButtonBack"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ChangeAddressDataAccountOwner"] }
                              Width={420}
                              Float={"left"}
                              OnClick={() => { this.jump((stepIdPayment), 0); }} />
                            </td>
                          </tr>
                    </tbody>
                  </table>);
              }
            } 
          }      
        }

      } else{

        if(this.state.ConfirmationsRequired === true){

          stepIdPayment = stepIdPayment + 1;
 
          if(this.state.NoPayment === true){
            payment = (
              <table id={"Payment"}>
                <tbody>
                <tr>
                  <td colSpan={3}>
                    <br/>
                    <br/>
                    <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                      <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                  </td>
                </tr>
                  <tr>
                    <td>
                    <div id={"Payment_NoPayment"} className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoPaymentNecessary"]}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          } else{

            if(document.getElementById('Payments') !== null) {

              if(this.CustomerId != "00000" && localStorage.getItem('vas_role') == 3){
                stepIdPayment = stepIdPayment - 1;
              }

              payment = (<table id={"Payment"}>
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      <br/>
                      <br/>
                      <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"Payment_LeftContainer"}>
                        <div id={"Payment_PaymentHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}:</b></div>
                    
                        <div id={"Payment_Payment"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>6</div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"Payment_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tbody>
              </table>);
            } else{
              payment = (<table id={"PaymentData"}>
                <tbody>
                    <tr>
                      <td colSpan={5}>
                          <br/>
                          <br/>
                          <div id={"PaymentDataHeadline"} style={{ width: '360px'}}>
                            <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                          </div>
                          <br/>
                          <br/>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_DepositorNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorName"]}:</b></div>

                          <div id={"PaymentData_DepositorName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>

                        <div id={"PaymentData_Empty"}></div>

                        <div id={"PaymentData_RightContainer"}>
                          <div id={"PaymentData_DepositorFirstnameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorFirstname"]}:</b></div>

                          <div id={"PaymentData_DepositorFirstname"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                          <div id={"PaymentData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_BicHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Bic"]}:</b></div>
                      
                          <div id={"PaymentData_Bic"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>
                      
                          <div id={"PaymentData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                    <td colspan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"PaymentData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tbody>
              </table>);

              if(this.state.CustomerEqualAccountOwner === false){
                accountOwnerAdressData = (<table id={"AddressDataAccountOwner"}>
                  <tbody>
                        <tr>
                          <td colSpan={5}>
                              <br/>
                              <br/>
                              <div id={"AddressDataAccountOwnerHeadline"} style={{ width: '430px'}}>
                                <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["AccountOwner"] }</b>
                              </div>
                              <br/>
                              <br/>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>

                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                            <td colspan={5}>
                            <br/>
                            <ExtendedButton
                              Id={"AddressDataAccountOwner_ButtonBack"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ChangeAddressDataAccountOwner"] }
                              Width={420}
                              Float={"left"}
                              OnClick={() => { this.jump((stepIdPayment), 0); }} />
                            </td>
                          </tr>
                    </tbody>
                  </table>);
              }
            }
          }

        } else{

          if(this.state.NoPayment === true){
            payment = (
              <table id={"Payment"}>
                <tbody>
                <tr>
                  <td colSpan={3}>
                    <br/>
                    <br/>
                    <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                      <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                    </div>
                    <br/>
                    <br/>
                  </td>
                </tr>
                  <tr>
                    <td>
                    <div id={"Payment_NoPayment"} className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoPaymentNecessary"]}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          } else{

            if(document.getElementById('Payments') !== null) {

              stepIdPayment = stepIdPayment + 1;

              payment = (<table id={"Payment"}>
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      <br/>
                      <br/>
                      <div id={"PaymentHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"Payment_LeftContainer"}>
                        <div id={"Payment_PaymentHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}:</b></div>
                    
                        <div id={"Payment_Payment"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>6</div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"Payment_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tbody>
              </table>);
            } else{

              stepIdPayment = stepIdPayment + 1;

              payment = (<table id={"PaymentData"}>
                <tbody>
                    <tr>
                      <td colSpan={5}>
                          <br/>
                          <br/>
                          <div id={"PaymentDataHeadline"} style={{ width: '360px'}}>
                            <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                          </div>
                          <br/>
                          <br/>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_DepositorNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorName"]}:</b></div>

                          <div id={"PaymentData_DepositorName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>

                        <div id={"PaymentData_Empty"}></div>

                        <div id={"PaymentData_RightContainer"}>
                          <div id={"PaymentData_DepositorFirstnameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorFirstname"]}:</b></div>

                          <div id={"PaymentData_DepositorFirstname"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                          <div id={"PaymentData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_BicHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Bic"]}:</b></div>
                      
                          <div id={"PaymentData_Bic"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div id={"PaymentData_LeftContainer"}>
                          <div id={"PaymentData_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>
                      
                          <div id={"PaymentData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                        </div>  
                      </td>
                    </tr>
                    <tr>
                    <td colspan={5}>
                      <br/>
                      <ExtendedButton
                        Id={"PaymentData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePaymentData"] }
                        Width={180}
                        Float={"left"}
                        OnClick={() => { this.jump((stepIdPayment), 0); }} />
                    </td>
                  </tr>
                </tbody>
              </table>);

              if(this.state.CustomerEqualAccountOwner === false){
                accountOwnerAdressData = (<table id={"AddressDataAccountOwner"}>
                    <tbody>
                        <tr>
                          <td colSpan={5}>
                              <br/>
                              <br/>
                              <div id={"AddressDataAccountOwnerHeadline"} style={{ width: '430px'}}>
                                <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["AccountOwner"] }</b>
                              </div>
                              <br/>
                              <br/>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>
                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                              <div id={"AddressDataAccountOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>

                            <div id={"AddressDataAccountOwner_Empty"}></div>

                            <div id={"AddressDataAccountOwner_RightContainer"}>
                              <div id={"AddressDataAccountOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '150px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div id={"AddressDataAccountOwner_LeftContainer"}>
                              <div id={"AddressDataAccountOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                              <div id={"AddressDataAccountOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                            </div>  
                          </td>
                        </tr>
                        <tr>
                            <td colspan={5}>
                            <br/>
                            <ExtendedButton
                              Id={"AddressDataAccountOwner_ButtonBack"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ChangeAddressDataAccountOwner"] }
                              Width={420}
                              Float={"left"}
                              OnClick={() => { this.jump((stepIdPayment), 0); }} />
                            </td>
                          </tr>
                    </tbody>
                  </table>);
              }
            }
          }
        }
      }


      return(<table style={{ width: '375px'}}>
        <tbody>
          <tr>
            <td>
              { tariffProduct }
              { personalDataTicketOwner }
              { addressDataTicketOwner }
              { payment }
              {accountOwnerAdressData}
            </td>
          </tr>
        </tbody>
      </table>);

    }

    buildStepperTable(number,title,content,buttonContinue,buttonBack,buttonOrder,buttonChange,buttonBackToCustomer){
      let btoContinue = '';
      if (buttonContinue === true){
        btoContinue = (<ExtendedButton
          Id={"buttonContinue" + number}
          Usable={true}
          Text={Vas.Resources.Labels["Continue"]}
          Float={"left"}
          Width={180}
          OnClick={() => { this.jump((number +1), number.toString()); }} />);
      }

      let btoBack = '';
      if (buttonBack === true){
        btoBack = (<ExtendedButton
          Id={"buttonBack" + number}
          Usable={true}
          Text={Vas.Resources.Labels["Back"]}
          Width={180}
          Float={"left"}
          OnClick={() => { this.jump((number -1), number.toString()); }} />);
      }

      let btoOrder = '';
      if (buttonOrder === true){
        btoOrder = (<ExtendedButton 
          ref={"Order"}
          Usable={true} 
          Text={Vas.Resources.Labels["OrderCosts"]} 
          OnClick={()=>{ this.Order();}} 
          Float={"left"} 
          Width={180} 
          Id={"btoOrderOrder"} />);
      }

      let btoChange = '';
      if(buttonChange === true){
        btoChange = (
          <ExtendedButton 
              ref={"Order"} 
              Usable={true} 
              Text={Vas.Resources.Labels["ChangeCosts"]} 
              OnClick={()=>{ this.Order();}} 
              Float={"left"} 
              Width={180} 
              Id={"btoOrderChange"} />
        );
      }

      let btoBackToCustomer = '';
      if(buttonBackToCustomer === true){
        btoBackToCustomer = (
          <ExtendedButton 
              Usable={true} 
              Text={Vas.Resources.Labels["BackToCustomer"]} 
              OnClick={()=>{ this.BackToCustomer();}} 
              Float={"left"} 
              Width={180} 
              Id={"btoBackCustomer"} />
        );
      }

      return (<table
        id={"StepperTable_" +title}
        className={"StepperTable"}>
        <tbody>
          <tr onClick={() => { this.jump(number.toString()); }}>
            <td><div
              id={"i" + number.toString()}
              className={"StepperIcon"} >{number}</div></td>
            <td><div className={"StepperLabel"}>{title}</div></td>
          </tr>
          <tr
            id={number.toString()}
            className={"c"} 
            style={{ display: 'none' }}>
            <td className={"StepperConnector"}></td>
            <td>
              {content}
              <br />
              {btoBack}
              {btoBackToCustomer}
              {btoContinue}
              {btoOrder}
              {btoChange}
            </td>
          </tr>
        </tbody>
      </table>);
    }

    buildStepperTableNotVisible(name,title,content){
      return (<table
        id={"StepperTable_" + name}
        className={"StepperTable"}
        style={{ display: 'none' }}>
        <tbody>
          <tr>
            <td></td>
            <td><div className={"StepperLabel"}>{title}</div></td>
          </tr>
          <tr>
            <td className={"StepperConnector"}></td>
            <td>
              {content}
            </td>
          </tr>
        </tbody>
      </table>);
    }

    //#endregion
    
    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $(".orderForm .StepperIconActive").attr('style', 'background-color: #1d5c87;');
        $('.orderForm .StepperIcon').attr('style', 'background-color: none;');
        $('.orderForm').attr('style', 'border: 1px solid #1d5c87;');
        $('.orderForm #buttonContinue1').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $('.orderForm .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

        $('.orderForm .selectField #TariffProducts').attr('style', 'width: 350px; border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #ContractStart').attr('style', 'width: 210px; border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #Via').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #ContractEnd').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonBack2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonContinue2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #TariffProduct_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #Payment_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonBack3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonContinue3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #btoOrderOrder').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #btoChooseDocument').attr('style', 'width: 150px; float: left; background-color: #1d5c87;');

        $(".orderForm .extendedButton").mouseenter(function() {
          $(this).attr('style', 'background-color: #00375b; width: 180px; float: left;');
      }).mouseleave(function() {
          $(this).attr('style', 'background-color: #1d5c87; width: 180px; float: left;');
      });

      $(".orderForm #btoChooseDocument").mouseenter(function() {
        $(this).attr('style', 'background-color: #00375b; width: 150px; float: left;');
    }).mouseleave(function() {
        $(this).attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
    });

    $('.textfieldDisabled').attr('style', 'width: 220px; border-bottom: 1px dotted #1d5c87;');

      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
  
      //Schriftgröße bei Klick in 2er Schritten erhöhen
  
        if(schriftgröße != null){
              switch(schriftgröße){
                case "0":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#Payment_ButtonBack').removeClass('marginTop_20').addClass('marginTop_25');

                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_26").addClass("Schriftgröße_28");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('.StepperLabel').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                  $('#TariffProduct_Empty').addClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                  $('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('.termsOfUsage').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
  
                break;
                case "1":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#Payment_ButtonBack').removeClass('marginTop_25');

                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_28").addClass("Schriftgröße_18");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('.StepperLabel').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                  $('#TariffProduct_Empty').removeClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                  $('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('.termsOfUsage').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
  
                break;
                case "2":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#Payment_ButtonBack').addClass('marginTop_5');

                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_18").addClass("Schriftgröße_20");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('.StepperLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                  $('#TariffProduct_Empty').removeClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                  $('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('.termsOfUsage').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                  $('html body div#root.Schriftgröße_17 div div div.form.orderForm table tbody tr td table#StepperTable_Auswahlliste Tarifprodukt.StepperTable tbody tr#1.c td div table tbody tr td div div table tbody tr td table tbody tr#RelationFromToVia td table tbody tr td div div div.autocomplete input#From.textfield').addClass("Schriftgröße_15");
                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                break;
                case "3":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#Payment_ButtonBack').removeClass('marginTop_5').addClass('marginTop_10');

                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_20").addClass("Schriftgröße_22");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                  $('#TariffProduct_Empty').removeClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                  $('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('.termsOfUsage').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
  
                break;
                case "4":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#Payment_ButtonBack').removeClass('marginTop_10').addClass('marginTop_15');

                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_22").addClass("Schriftgröße_24");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('.StepperLabel').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                  $('#TariffProduct_Empty').addClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                  $('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('.termsOfUsage').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
  
                break;
                case "5":
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#Payment_ButtonBack').removeClass('marginTop_15').addClass('marginTop_20');
                  $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_24").addClass("Schriftgröße_26");
                  $('.ConfirmationLabel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('.StepperLabel').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                  $('#TariffProduct_Empty').addClass('tariffProductEmptyHeight_25');

                  $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                  $('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('.termsOfUsage').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                  $('.StepperTable tbody tr#3.c td table tbody tr td#confirmationFields table tbody tr td table tbody tr td div.ex button#btoChooseDocument.extendedButton').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                break;
              }
        }
    };

    handleChange(){
      if(localStorage.getItem("TariffProduct") != null)
      {
        if(document.getElementById("Motiv1").checked) {
          var motiv1 = JSON.parse(localStorage.getItem("Motiv1"));
          localStorage.setItem("TariffProduct", JSON.stringify(motiv1[0]));
        } else if(document.getElementById("Motiv2").checked) {
          var motiv2 = JSON.parse(localStorage.getItem("Motiv2"));
          localStorage.setItem("TariffProduct", JSON.stringify(motiv2[0]));
        } else if(document.getElementById("Motiv3").checked) {
          var motiv3 = JSON.parse(localStorage.getItem("Motiv3"));
          localStorage.setItem("TariffProduct", JSON.stringify(motiv3[0]));
        }
      }
     };

    render()
    {
        this.FontSizeClick();

        let tariffing = this.buildStepperTable(1,Vas.Resources.Labels["Product"],this.setStepTariffing(),true);
        if(localStorage.getItem('vas_role') === '3'){
          tariffing = this.buildStepperTable(1,Vas.Resources.Labels["Product"],this.setStepTariffing(),true,false,false,false,true);
        }

        let idx = 2
        // let customer = this.buildStepperTable(idx,Vas.Resources.Labels["ContractUser"],this.setStepperCustomer(),true,true);
        // idx++;
        
        // if(localStorage.getItem('vas_role') === '3'){
          // customer = this.buildStepperTableNotVisible("Customer",Vas.Resources.Labels["ContractUser"],this.setStepperCustomer());
          // idx--;
        // }
        let customerData = this.buildStepperTableNotVisible("CustomerData",Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"],this.setStepCustomerPersonal());
        let customerAdress = this.buildStepperTableNotVisible("CustomerAdress",Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"],this.setStepCustomerAdress());

        if(this.state.IamCustomer === false){
          customerData = this.buildStepperTable(idx,Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"],this.setStepCustomerPersonal(),true,true);
          idx++;
          customerAdress = this.buildStepperTable(idx,Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"],this.setStepCustomerAdress(),true,true);
          idx++;
        }

        let payment = this.buildStepperTable(idx,Vas.Resources.Labels["MethodOfPaymentCustomer"],this.setStepperPayment(),true,true);
        idx++;

        let verification = this.buildStepperTableNotVisible("Verification",Vas.Resources.Labels["RequiredCertificates"],this.setStepVerifications());
        if(this.state.ConfirmationsRequired === true){
          verification = this.buildStepperTable(idx,Vas.Resources.Labels["RequiredCertificates"],this.setStepVerifications(),true,true);
          idx++;
        }
        
        //let order = '';
        let finishOrder = '';
        let contract = <tr></tr>;
        let customerHint = <tr></tr>;

        if (this.ContractId !== '00000'){
         
          // order = this.buildStepperTable(idx,Vas.Resources.Labels["ContractChange"],this.setStepperOrder(),false,true,false,true);
          finishOrder = this.buildStepperTable(idx,Vas.Resources.Labels["ConfirmOrder"],this.setStepperFinishOrder(),false,true,false,true);
          contract = <tr>
          <th>
            <table id={"HintContractStart"}>
              <tbody>
                <tr>
                  <td colSpan={2}>
                    <br/>
                    {Vas.Resources.Labels["ContractChangeNote"]}
                  </td>
                </tr>
                <tr>
                  <td style={{float:"left"}}>
                    {Vas.Resources.Labels["ContractNumber"]}:
                  </td>
                  <td style={{float:"left"}}>
                    {this.state.Contract.ContractNumber}
                  </td>
                </tr>
                <tr>
                  <td style={{float:"left"}}>
                    {Vas.Resources.Labels["TicketName"]}:
                  </td>
                  <td style={{float:"left"}}>
                    {this.state.Contract.TicketName}
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
        } else {
          //order = this.buildStepperTable(idx,Vas.Resources.Labels["OrderCosts"],this.setStepperOrder(),false,true,true);
          finishOrder = this.buildStepperTable(idx,Vas.Resources.Labels["ConfirmOrder"],this.setStepperFinishOrder(),false,true,true);
        }

        if(this.CustomerId !== "00000"){
          if(localStorage.getItem('employee_name2')){

            let customerName = '';

            if(localStorage.getItem('vas_role') === '1'){
              customerName = (<tr>
                <td colSpan={2} style={{float:"left"}}>
                  {localStorage.getItem('employee_name2') + " " + localStorage.getItem('employee_name1')}
                </td>
              </tr>);

            } else if(localStorage.getItem('vas_role') === '3'){
              customerName = (<tr>
                <td style={{float:"left"}}>
                  {Vas.Resources.Labels["Customer"]}:
                </td>
                <td style={{float:"left"}}>
                  {localStorage.getItem('employee_name2') + " " + localStorage.getItem('employee_name1')}
                </td>
              </tr>);
            }

            customerHint = <tr>
            <th>
              <table id={"HintCustomer"}>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{float:"left"}}>
                      <br/>
                      {Vas.Resources.Labels["ContractFor"]}
                    </td>
                  </tr>
                  {customerName}
                </tbody>
              </table>
            </th>
          </tr>
  
          }
          if (this.ContractId !== '00000'){
            if(this.state.Contract){

              let customerName = '';

              if(localStorage.getItem('vas_role') === '1'){
                customerName = (<tr>
                  <td colSpan={2} style={{float:"left"}}>
                  {this.state.Contract.CustomerName}
                  </td>
                </tr>);

              } else if(localStorage.getItem('vas_role') === '3'){
                customerName = (<tr>
                  <td style={{float:"left"}}>
                    {Vas.Resources.Labels["Customer"]}:
                  </td>
                  <td style={{float:"left"}}>
                  {this.state.Contract.CustomerName}
                  </td>
                </tr>);
              }

              customerHint = <tr>
              <th>
                <table id={"HintCustomer"}>
                  <tbody>
                    <tr>
                      <td colSpan={2} style={{float:"left"}}>
                        <br/>
                        {Vas.Resources.Labels["ContractFor"]}
                      </td>
                    </tr>
                    { customerName }
                  </tbody>
                </table>
              </th>
            </tr>
            }
          }
          
        }

        return (<div className={"form orderForm"}>
          <table style={{ width:'100%' }}>
            <thead>
            {/*<tr>
                  <th >
                    <div id={"HintContractStart"} style={{textAlign:"center",fontWeight:"normal",fontSize:"14px"}}>
                      {Vas.Resources.Labels["InfoText"]}
                    </div>
                  </th>
            </tr>*/}
                {customerHint}
                {contract}
              <tr >
                <th>
                  <h2 id={"orderFormHeadline"}>{Vas.Resources.Labels["Order"]}</h2>
                </th>
              </tr>
              <tr>
                <th>
                  <div id={"HintMaxAge"} className={"HintRequiredAgeLoggedIn"}></div>
                </th>
              </tr>
              <tr>
                <th>
                  <div id={"HintRequiredAge"} className={"HintRequiredAgeLoggedIn"}></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{textAlign:'justify'}}>
                  {tariffing}
				  {/*{customer} */}
                  {customerData}
                  {customerAdress}
                  {payment}
                  {verification}
                   {/* {order}  */}
                  {finishOrder}
                </td>
              </tr>
            </tbody>
          </table>
            
          </div>);
    }
}
export default Order;
